// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS file for table dialog in the table plugin */

.editor-container.adg3-editor #rte-ellipsis-menu.aui-dropdown2.aui-style-default,
#content.edit.adg3-editor #rte-ellipsis-menu.aui-dropdown2.aui-style-default {
	border-radius: 5px;
}

.editor-container.adg3-editor
	#rte-ellipsis-menu.aui-dropdown2.aui-style-default
	.aui-dropdown2-section
	li
	a:hover,
#content.edit.adg3-editor
	#rte-ellipsis-menu.aui-dropdown2.aui-style-default
	.aui-dropdown2-section
	li
	a:hover {
	background-color: var(--ds-background-input-hovered, #f2f2f2);
	color: var(--ds-text, #333);
}

.editor-container.adg3-editor #toolbar,
#content.edit.adg3-editor #toolbar {
	background-color: var(--ds-surface-sunken, #f5f5f5);
}

.editor-container.adg3-editor #toolbar #rte-button-color,
#content.edit.adg3-editor #toolbar #rte-button-color,
.editor-container.adg3-editor #toolbar #rte-button-insert-table,
#content.edit.adg3-editor #toolbar #rte-button-insert-table,
.editor-container.adg3-editor #toolbar #rte-button-insert,
#content.edit.adg3-editor #toolbar #rte-button-insert,
.editor-container.adg3-editor #toolbar #rte-button-pagelayout,
#content.edit.adg3-editor #toolbar #rte-button-pagelayout,
.editor-container.adg3-editor #toolbar #rte-button-insert-template,
#content.edit.adg3-editor #toolbar #rte-button-insert-template {
	padding: 0 6px;
}

.editor-container.adg3-editor #toolbar #rte-button-more .icon-dropdown,
#content.edit.adg3-editor #toolbar #rte-button-more .icon-dropdown {
	margin-left: 3px;
}

.editor-container.adg3-editor #toolbar #rte-button-pagelayout-2,
#content.edit.adg3-editor #toolbar #rte-button-pagelayout-2 {
	margin: 0;
	padding: 0 4px;
}

.editor-container.adg3-editor #toolbar #rte-button-pagelayout-2 .aui-iconfont-editor-layout:before,
#content.edit.adg3-editor #toolbar #rte-button-pagelayout-2 .aui-iconfont-editor-layout:before {
	right: 0;
	margin-left: -3px;
}

.editor-container.adg3-editor #toolbar #confluence-insert-files,
#content.edit.adg3-editor #toolbar #confluence-insert-files {
	padding: 0;
}

.editor-container.adg3-editor #toolbar #confluence-insert-files a.toolbar-trigger,
#content.edit.adg3-editor #toolbar #confluence-insert-files a.toolbar-trigger {
	padding: 0 4px;
}

.editor-container.adg3-editor #toolbar #confluence-insert-files .aui-iconfont-editor-files:before,
#content.edit.adg3-editor #toolbar #confluence-insert-files .aui-iconfont-editor-files:before {
	right: 0;
	margin-left: -3px;
}

.editor-container.adg3-editor #toolbar #rte-button-link,
#content.edit.adg3-editor #toolbar #rte-button-link {
	margin: 0;
	padding: 0 4px;
}

.editor-container.adg3-editor #toolbar #rte-button-link .aui-iconfont-link:before,
#content.edit.adg3-editor #toolbar #rte-button-link .aui-iconfont-link:before {
	right: 0;
	margin-left: -3px;
}

.editor-container.adg3-editor #toolbar #rte-button-link .trigger-text,
#content.edit.adg3-editor #toolbar #rte-button-link .trigger-text,
.editor-container.adg3-editor #toolbar #confluence-insert-files > .trigger-text,
#content.edit.adg3-editor #toolbar #confluence-insert-files > .trigger-text,
.editor-container.adg3-editor #toolbar #insert-table-dropdown .dropdown-text,
#content.edit.adg3-editor #toolbar #insert-table-dropdown .dropdown-text,
.editor-container.adg3-editor #toolbar #insert-menu .dropdown-text,
#content.edit.adg3-editor #toolbar #insert-menu .dropdown-text,
.editor-container.adg3-editor #toolbar #rte-button-insert-template .dropdown-text,
#content.edit.adg3-editor #toolbar #rte-button-insert-template .dropdown-text {
	display: none;
}

.editor-container.adg3-editor #toolbar #confluence-insert-files #rte-button-link .icon-dropdown,
#content.edit.adg3-editor #toolbar #confluence-insert-files #rte-button-link .icon-dropdown,
.editor-container.adg3-editor #toolbar #insert-table-dropdown .icon-dropdown,
#content.edit.adg3-editor #toolbar #insert-table-dropdown .icon-dropdown,
.editor-container.adg3-editor #toolbar #insert-menu .icon-dropdown,
#content.edit.adg3-editor #toolbar #insert-menu .icon-dropdown,
.editor-container.adg3-editor #toolbar #rte-button-pagelayout .icon-dropdown,
#content.edit.adg3-editor #toolbar #rte-button-pagelayout .icon-dropdown,
.editor-container.adg3-editor #toolbar #rte-button-insert-template .icon-dropdown,
#content.edit.adg3-editor #toolbar #rte-button-insert-template .icon-dropdown {
	width: 22px;
	margin-left: 0;
	padding-right: 0;
}

.editor-container.adg3-editor #toolbar #rte-button-pagelayout .icon-layout,
#content.edit.adg3-editor #toolbar #rte-button-pagelayout .icon-layout {
	margin-top: 2px;
}

.editor-container.adg3-editor #toolbar li#insert-table-dropdown,
#content.edit.adg3-editor #toolbar li#insert-table-dropdown,
.editor-container.adg3-editor #toolbar #pagelayout-menu,
#content.edit.adg3-editor #toolbar #pagelayout-menu,
.editor-container.adg3-editor #toolbar #page-layout-2,
#content.edit.adg3-editor #toolbar #page-layout-2,
.editor-container.adg3-editor #toolbar #table-highlight-colour,
#content.edit.adg3-editor #toolbar #table-highlight-colour,
.editor-container.adg3-editor #toolbar #format-dropdown,
#content.edit.adg3-editor #toolbar #format-dropdown,
.editor-container.adg3-editor #toolbar #template-menu,
#content.edit.adg3-editor #toolbar #template-menu {
	/* template editor */
	padding: 0;
}

.editor-container.adg3-editor #toolbar #rte-button-cancel.shared-drafts,
#content.edit.adg3-editor #toolbar #rte-button-cancel.shared-drafts {
	/* button.aui-button height is 28px with default styles */
	height: 26px;
	padding: 0 6px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar-row-default,
#content.edit.adg3-editor #toolbar #rte-toolbar-row-default,
.editor-container.adg3-editor #toolbar #rte-toolbar-row-pl2-toolbar,
#content.edit.adg3-editor #toolbar #rte-toolbar-row-pl2-toolbar,
.editor-container.adg3-editor #toolbar #rte-toolbar-row-searchreplace,
#content.edit.adg3-editor #toolbar #rte-toolbar-row-searchreplace {
	height: 35px;
	padding-top: 10px;
}

.editor-container.adg3-editor #toolbar #adg3-charlie-icon svg,
#content.edit.adg3-editor #toolbar #adg3-charlie-icon svg {
	color: var(--ds-icon-subtle, #cccccc);
	margin: 0 8px 0 10px;
	height: 24px;
	width: 24px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar,
#content.edit.adg3-editor #toolbar #rte-toolbar {
	background-color: var(--ds-surface-sunken, #f5f5f5);
	z-index: 2;
	position: relative;
	height: 100%;
	display: flex;
	flex-wrap: nowrap;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-primary,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-primary,
.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual {
	padding-top: 26px;
	padding-bottom: 26px;
	background-color: var(--ds-surface-sunken, #f5f5f5);
	margin-right: 0px;
	padding-right: 0px;
	flex-grow: 1;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-primary .aui-buttons.no-separator,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-primary .aui-buttons.no-separator,
.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons.no-separator,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons.no-separator {
	margin-right: 0px;
	margin-left: 0px;
	padding: 0 1px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar2-primary
	.aui-buttons
	.aui-button:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar2-primary
	.aui-buttons
	.aui-button:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	.aui-button:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons .aui-button:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar2-primary
	.aui-buttons
	.toolbar-item:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar2-primary
	.aui-buttons
	.toolbar-item:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	.toolbar-item:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	.toolbar-item:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar2-primary
	.aui-buttons
	.toolbar-trigger:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar2-primary
	.aui-buttons
	.toolbar-trigger:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	.toolbar-trigger:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	.toolbar-trigger:hover {
	cursor: pointer;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary {
	position: static;
	padding-top: 25px;
	display: flex;
	flex-wrap: nowrap;
	margin-right: 5px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .aui-dd-parent a.aui-dd-trigger,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-dd-parent a.aui-dd-trigger {
	position: relative;
	line-height: 24px;
	font-size: 12px;
	border-radius: 3px;
	text-shadow: none;
	text-decoration: none;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .aui-dd-parent a.aui-dd-trigger:after,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-dd-parent a.aui-dd-trigger:after {
	margin-top: -3px;
	/* Using icon as a border color because this :after is for the triangle caret icons in the button */
	border-top-color: var(--ds-icon, #405070);
}

.editor-container.adg3-editor #toolbar #rte-toolbar .aui-dd-parent a#rte-button-color,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-dd-parent a#rte-button-color {
	padding: 0;
	margin: 0;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .aui-dd-parent.active > a.aui-dd-trigger:after,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-dd-parent.active > a.aui-dd-trigger:after {
	border-top-color: var(--ds-border-inverse, #fff);
}

.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual.disabled,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual.disabled,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-pl2-toolbar.disabled,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-pl2-toolbar.disabled,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-default.disabled,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-default.disabled,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-searchreplace.disabled,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-searchreplace.disabled {
	/* Make invisible, we can't beat an inline display block, so we shrink the height to 0*/
	min-height: 0;
	overflow: hidden;
	padding-top: 0;
	border-bottom: 1px solid var(--ds-border-disabled, rgba(0, 0, 0, 0));
	background-color: var(--ds-surface, white);
	min-height: 0;
	height: 0;
	opacity: 0;
	-webkit-transition:
		min-height 0.35s ease,
		height 0.35s ease,
		padding 0.1s ease,
		opacity 0.5s ease-out,
		border 0.75s linear;
	-moz-transition:
		min-height 0.35s ease,
		height 0.35s ease,
		padding 0.1s ease,
		opacity 0.5s ease-out,
		border 0.75s linear;
	transition:
		min-height 0.35s ease,
		height 0.35s ease,
		padding 0.1s ease,
		opacity 0.5s ease-out,
		border 0.75s linear;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual {
	position: absolute;
	top: 88px;
	left: 0px;
	padding: 6px 0 0 25px;
	margin-left: 0;
	min-height: 32px;
	opacity: 1;
	display: block;
	background-color: var(--ds-surface, white);
	border-bottom: 1px solid var(--ds-border, #ccc);
	-webkit-transition:
		min-height 0.35s ease,
		height 0.35s ease,
		padding 0.1s ease,
		opacity 0.5s ease-in,
		border 0.75s ease-in;
	-moz-transition:
		min-height 0.35s ease,
		height 0.35s ease,
		padding 0.1s ease,
		opacity 0.5s ease-in,
		border 0.75s ease-in;
	transition:
		min-height 0.35s ease,
		height 0.35s ease,
		padding 0.1s ease,
		opacity 0.5s ease-in,
		border 0.75s ease-in;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-searchreplace
	.aui-buttons.close,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-searchreplace
	.aui-buttons.close,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-pl2-toolbar
	.aui-buttons.close,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-pl2-toolbar
	.aui-buttons.close {
	position: absolute;
	right: 42px;
	top: 8px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons.close
	.aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons.close .aui-button {
	border: 0;
	box-shadow: none;
	padding: 0;
	margin-top: 4px;
	height: 16px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	.toolbar-item
	> label,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	.toolbar-item
	> label {
	color: var(--ds-text-subtle, #405070);
}

.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons .aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons .aui-button,
.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons a.aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons a.aui-button,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	.aui-button:visited,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	.aui-button:visited,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	.toolbar-item
	label,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	.toolbar-item
	label {
	font-size: 13px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	button.aui-button[data-tooltip='Close'],
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	button.aui-button[data-tooltip='Close'] {
	height: 24px;
	width: 24px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	button.aui-button[data-tooltip='Close']:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	button.aui-button[data-tooltip='Close']:before {
	left: 1px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-default
	.aui-buttons,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-default
	.aui-buttons,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-pl2-toolbar
	.aui-buttons,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-pl2-toolbar
	.aui-buttons {
	top: 3px;
	position: relative;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual#rte-toolbar-row-pl2-toolbar,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual#rte-toolbar-row-pl2-toolbar {
	padding-left: 32px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-searchreplace,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual#rte-toolbar-row-searchreplace {
	padding-left: 39px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-searchreplace
	.aui-buttons.close,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual#rte-toolbar-row-searchreplace
	.aui-buttons.close {
	right: 47px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar li.aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar li.aui-button {
	display: inline-block;
	padding: 0;
	width: 24px;
	text-align: center;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #color-picker-control,
#content.edit.adg3-editor #toolbar #rte-toolbar #color-picker-control,
.editor-container.adg3-editor #toolbar #rte-toolbar #more-menu,
#content.edit.adg3-editor #toolbar #rte-toolbar #more-menu {
	float: none;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #insert-menu,
#content.edit.adg3-editor #toolbar #rte-toolbar #insert-menu,
.editor-container.adg3-editor #toolbar #rte-toolbar #insert-table-dropdown,
#content.edit.adg3-editor #toolbar #rte-toolbar #insert-table-dropdown {
	padding: 0;
	width: 42px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #insert-menu .aui-dd-parent.active:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar #insert-menu .aui-dd-parent.active:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#insert-table-dropdown
	.aui-dd-parent.active:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar #insert-table-dropdown .aui-dd-parent.active:hover {
	color: inherit;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#insert-menu
	#insert-menu-options
	.grouped-dropdown-item:last-child,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#insert-menu
	#insert-menu-options
	.grouped-dropdown-item:last-child {
	border-top: none;
	margin-top: 0;
	padding-top: 0;
}

.editor-container.adg3-editor #toolbar #rte-toolbar a#rte-button-more,
#content.edit.adg3-editor #toolbar #rte-toolbar a#rte-button-more,
.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert-table,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert-table,
.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert,
.editor-container.adg3-editor #toolbar #rte-toolbar #color-picker-control,
#content.edit.adg3-editor #toolbar #rte-toolbar #color-picker-control {
	border-radius: 3px;
	padding: 0;
	width: 42px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar a#rte-button-more .aui-iconfont-add,
#content.edit.adg3-editor #toolbar #rte-toolbar a#rte-button-more .aui-iconfont-add,
.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert-table .aui-iconfont-add,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert-table .aui-iconfont-add,
.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert .aui-iconfont-add,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert .aui-iconfont-add,
.editor-container.adg3-editor #toolbar #rte-toolbar #color-picker-control .aui-iconfont-add,
#content.edit.adg3-editor #toolbar #rte-toolbar #color-picker-control .aui-iconfont-add,
.editor-container.adg3-editor #toolbar #rte-toolbar a#rte-button-more .aui-iconfont-editor-table,
#content.edit.adg3-editor #toolbar #rte-toolbar a#rte-button-more .aui-iconfont-editor-table,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-insert-table
	.aui-iconfont-editor-table,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert-table .aui-iconfont-editor-table,
.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert .aui-iconfont-editor-table,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert .aui-iconfont-editor-table,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#color-picker-control
	.aui-iconfont-editor-table,
#content.edit.adg3-editor #toolbar #rte-toolbar #color-picker-control .aui-iconfont-editor-table {
	width: 24px;
	left: 6px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar a#rte-button-more .aui-iconfont-dropdown,
#content.edit.adg3-editor #toolbar #rte-toolbar a#rte-button-more .aui-iconfont-dropdown,
.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert-table .aui-iconfont-dropdown,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert-table .aui-iconfont-dropdown,
.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert .aui-iconfont-dropdown,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert .aui-iconfont-dropdown,
.editor-container.adg3-editor #toolbar #rte-toolbar #color-picker-control .aui-iconfont-dropdown,
#content.edit.adg3-editor #toolbar #rte-toolbar #color-picker-control .aui-iconfont-dropdown {
	width: 18px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	a#rte-button-more
	.icon.aui-iconfont-editor-styles,
#content.edit.adg3-editor #toolbar #rte-toolbar a#rte-button-more .icon.aui-iconfont-editor-styles,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-insert-table
	.icon.aui-iconfont-editor-styles,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-insert-table
	.icon.aui-iconfont-editor-styles,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-insert
	.icon.aui-iconfont-editor-styles,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert .icon.aui-iconfont-editor-styles,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#color-picker-control
	.icon.aui-iconfont-editor-styles,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#color-picker-control
	.icon.aui-iconfont-editor-styles {
	width: 24px;
	text-align: center;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	a#rte-button-more
	.icon.aui-iconfont-editor-styles:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	a#rte-button-more
	.icon.aui-iconfont-editor-styles:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-insert-table
	.icon.aui-iconfont-editor-styles:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-insert-table
	.icon.aui-iconfont-editor-styles:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-insert
	.icon.aui-iconfont-editor-styles:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-insert
	.icon.aui-iconfont-editor-styles:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#color-picker-control
	.icon.aui-iconfont-editor-styles:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#color-picker-control
	.icon.aui-iconfont-editor-styles:before {
	left: 2px;
	text-align: center;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #color-picker-control,
#content.edit.adg3-editor #toolbar #rte-toolbar #color-picker-control {
	width: 37px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert:after,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert:after,
.editor-container.adg3-editor #toolbar #rte-toolbar a#rte-button-more:after,
#content.edit.adg3-editor #toolbar #rte-toolbar a#rte-button-more:after {
	left: 28px;
	margin: -3px 0 0 0;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons
	.toolbar-dropdown.active
	.aui-dd-parent
	a.toolbar-trigger.aui-dd-trigger.aui-button,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons
	.toolbar-dropdown.active
	.aui-dd-parent
	a.toolbar-trigger.aui-dd-trigger.aui-button {
	background-color: var(--ds-background-brand-bold-hovered, #405070);
	background-image: none;
	color: var(--ds-text-inverse, #fff);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons
	.toolbar-dropdown.active
	.aui-dd-parent
	a.toolbar-trigger.aui-dd-trigger.aui-button:after,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons
	.toolbar-dropdown.active
	.aui-dd-parent
	a.toolbar-trigger.aui-dd-trigger.aui-button:after {
	border-top-color: var(--ds-border-inverse, #fff);
}

.editor-container.adg3-editor #toolbar #rte-toolbar #rte-toolbar-row-default .aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-toolbar-row-default .aui-button {
	height: 24px;
	padding: 0px 4px;
	outline: none;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #rte-toolbar-row-default .aui-button:active,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-toolbar-row-default .aui-button:active {
	background: var(--ds-background-neutral-pressed, rgba(179, 212, 255, 0.6));
	color: var(--ds-link-pressed, #0052cc);
	box-shadow: none;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons
	button
	.icon.aui-icon-small:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons
	button
	.icon.aui-icon-small:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons
	button
	.icon.aui-icon-large:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons
	button
	.icon.aui-icon-large:before {
	margin-left: -3px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons
	button
	.icon.aui-iconfont-table-header-row:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons
	button
	.icon.aui-iconfont-table-header-row:before {
	content: '\\f19c';
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-dropdown.disabled
	.aui-dd-parent
	> a.aui-dd-trigger:hover:after,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-dropdown.disabled
	.aui-dd-parent
	> a.aui-dd-trigger:hover:after,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton.disabled
	.aui-dd-parent
	> a.aui-dd-trigger:hover:after,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton.disabled
	.aui-dd-parent
	> a.aui-dd-trigger:hover:after {
	/* Using icon as a border color because this :after is for the triangle caret icons in the button */
	border-top-color: var(--ds-icon, #405070);
}

.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton:hover {
	background-color: var(--ds-background-input-hovered, #ffffff);
}

.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary .aui-buttons,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary .aui-buttons,
.editor-container.adg3-editor #toolbar #rte-toolbar .aui-buttons.no-separator,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-buttons.no-separator,
.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons:first-child,
#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons:first-child,
.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons:nth-of-type(2),
#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons:nth-of-type(2),
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons:first-child,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-toolbar-row-default .aui-buttons:first-child,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar
	.aui-buttons:first-child,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar
	.aui-buttons:first-child,
.editor-container.adg3-editor #toolbar #rte-toolbar .aui-buttons.close,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-buttons.close {
	border-left: none;
	padding-left: 0;
	/*Relative resize table*/
}

.editor-container.adg3-editor #toolbar #rte-toolbar ul.table-mode-list,
#content.edit.adg3-editor #toolbar #rte-toolbar ul.table-mode-list {
	list-style: none;
	margin: 0;
	padding: 5px 0;
}

.editor-container.adg3-editor #toolbar #rte-toolbar ul.table-mode-list .item-link,
#content.edit.adg3-editor #toolbar #rte-toolbar ul.table-mode-list .item-link {
	padding-right: 20px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar ul.table-mode-list .dropdown-item,
#content.edit.adg3-editor #toolbar #rte-toolbar ul.table-mode-list .dropdown-item {
	line-height: 18px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual.disabled,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual.disabled,
.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-item.disabled,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-item.disabled,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-button[disabled]
	.icon,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-button[disabled]
	.icon {
	color: var(--ds-icon-disabled, #707070);
	opacity: 0.5;
	cursor: not-allowed;
	border-bottom: 0;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .disabled a,
#content.edit.adg3-editor #toolbar #rte-toolbar .disabled a,
.editor-container.adg3-editor #toolbar #rte-toolbar .disabled span,
#content.edit.adg3-editor #toolbar #rte-toolbar .disabled span,
.editor-container.adg3-editor #toolbar #rte-toolbar .disabled button,
#content.edit.adg3-editor #toolbar #rte-toolbar .disabled button,
.editor-container.adg3-editor #toolbar #rte-toolbar .disabled div,
#content.edit.adg3-editor #toolbar #rte-toolbar .disabled div,
.editor-container.adg3-editor #toolbar #rte-toolbar .disabled li,
#content.edit.adg3-editor #toolbar #rte-toolbar .disabled li {
	cursor: not-allowed !important;
	opacity: 1;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .disabled#rte-button-help,
#content.edit.adg3-editor #toolbar #rte-toolbar .disabled#rte-button-help,
.editor-container.adg3-editor #toolbar #rte-toolbar .disabled#rte-button-help a,
#content.edit.adg3-editor #toolbar #rte-toolbar .disabled#rte-button-help a,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.disabled#rte-button-help
	a
	.aui-iconfont-editor-help,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.disabled#rte-button-help
	a
	.aui-iconfont-editor-help {
	cursor: pointer !important;
	opacity: 1;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	.aui-buttons.close
	.aui-button
	.aui-iconfont-close-dialog:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	.aui-buttons.close
	.aui-button
	.aui-iconfont-close-dialog:before {
	margin-top: -2px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar2-secondary
	ul.aui-buttons:last-child,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary ul.aui-buttons:last-child {
	margin-right: 0;
	/*
     ADG3 invite to edit
     */
}

.editor-container.adg3-editor #toolbar #rte-toolbar .adg3InviteToEdit,
#content.edit.adg3-editor #toolbar #rte-toolbar .adg3InviteToEdit {
	position: relative;
	top: -3px;
	left: -5px;
	display: inline-block;
	height: 32px;
	width: 32px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .adg3InviteToEdit #inviteToEditLink,
#content.edit.adg3-editor #toolbar #rte-toolbar .adg3InviteToEdit #inviteToEditLink {
	position: static;
	right: 0;
	bottom: 0;
	background: none;
	border: none;
	padding: 0;
	margin: 8px;
	width: 16px;
	height: 16px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.adg3InviteToEdit
	#inviteToEditLink
	.invite-plus-icon,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.adg3InviteToEdit
	#inviteToEditLink
	.invite-plus-icon {
	height: 12px;
	width: 2px;
	background-color: var(--ds-background-neutral-bold, #707070);
	display: block;
	margin: 0 auto;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.adg3InviteToEdit
	#inviteToEditLink
	.invite-plus-icon:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.adg3InviteToEdit
	#inviteToEditLink
	.invite-plus-icon:before {
	content: '';
	height: 2px;
	width: 12px;
	background-color: var(--ds-background-neutral-bold, #707070);
	display: table-caption;
	margin-left: -5px;
	margin-top: 5px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .adg3InviteToEdit #inviteToEditLink:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar .adg3InviteToEdit #inviteToEditLink:hover {
	background-color: var(--ds-background-input, rgba(9, 30, 66, 0.08));
	border-radius: 2px;
	/*
     remove separator
     - between lists | task list
     - block formatting
     */
}

.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons,
#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons {
	height: 28px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-button,
.editor-container.adg3-editor #toolbar #rte-toolbar a.aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar a.aui-button,
.editor-container.adg3-editor #toolbar #rte-toolbar .aui-button:visited,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-button:visited {
	border: none;
	/* table toolbar <buttons> */
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	button.aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons button.aui-button {
	margin-right: 1px;
	color: var(--ds-text, #405070);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	button.aui-button:hover:not(.disabled),
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	button.aui-button:hover:not(.disabled) {
	background-color: var(--ds-background-input, rgba(9, 30, 66, 0.08));
	border-radius: 2px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-searchreplace.toolbar-contextual
	.aui-buttons
	button.aui-button.disabled[aria-disabled='true']:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-searchreplace.toolbar-contextual
	.aui-buttons
	button.aui-button.disabled[aria-disabled='true']:hover {
	color: var(--ds-text-subtle, #405070);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-searchreplace.toolbar-contextual
	.aui-buttons
	button.aui-button[aria-disabled='true']:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-searchreplace.toolbar-contextual
	.aui-buttons
	button.aui-button[aria-disabled='true']:hover {
	color: var(--ds-text-inverse, #ffffff);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	button[aria-disabled='true'].aui-button,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	button[aria-disabled='true'].aui-button {
	background-color: var(--ds-background-input, #ffffff);
	color: var(--ds-text-subtle, #405070);
	cursor: not-allowed;
	opacity: 0.5;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	button.aui-button.disabled:hover
	.icon:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	button.aui-button.disabled:hover
	.icon:before {
	color: var(--ds-icon-disabled, #405070);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	button.aui-button#table-more-settings-trigger
	.aui-icon:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	.aui-buttons
	button.aui-button#table-more-settings-trigger
	.aui-icon:before {
	top: -4px;
	left: -3px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar
	.aui-dropdown2-trigger.toolbar-trigger.active,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar
	.aui-dropdown2-trigger.toolbar-trigger.active,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar
	.toolbar-splitbutton:hover
	.toolbar-trigger,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar
	.toolbar-splitbutton:hover
	.toolbar-trigger,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar
	.toolbar-group
	.toolbar-trigger:focus,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar .toolbar-group .toolbar-trigger:focus,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar
	.toolbar-group
	.toolbar-trigger:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar .toolbar-group .toolbar-trigger:hover,
.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar .toolbar-group button:focus,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar .toolbar-group button:focus,
.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar .toolbar-group button:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar .toolbar-group button:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar
	.aui-dd-parent
	.aui-dd-trigger:focus,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar .aui-dd-parent .aui-dd-trigger:focus,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar
	.aui-dd-parent
	.aui-dd-trigger:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar .aui-dd-parent .aui-dd-trigger:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar
	.toolbar-group
	.active
	.toolbar-trigger:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar
	.toolbar-group
	.active
	.toolbar-trigger:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar2-primary
	.toolbar-splitbutton
	.toolbar-trigger:hover
	.aui-buttons
	li.toolbar-splitbutton:hover
	a:hover.toolbar-trigger#rte-button-color,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar2-primary
	.toolbar-splitbutton
	.toolbar-trigger:hover
	.aui-buttons
	li.toolbar-splitbutton:hover
	a:hover.toolbar-trigger#rte-button-color,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li.toolbar-splitbutton
	a:hover.toolbar-trigger#rte-button-color,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li.toolbar-splitbutton
	a:hover.toolbar-trigger#rte-button-color,
.editor-container.adg3-editor #toolbar #rte-toolbar .aui-buttons li.toolbar-dropdown:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-buttons li.toolbar-dropdown:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li.toolbar-dropdown
	a:hover.toolbar-trigger,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li.toolbar-dropdown
	a:hover.toolbar-trigger {
	margin-left: 0;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li#color-picker-control.toolbar-splitbutton.disabled:hover
	> .aui-dd-parent:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li#color-picker-control.toolbar-splitbutton.disabled:hover
	> .aui-dd-parent:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li#color-picker-control.toolbar-splitbutton.disabled:hover
	> .aui-dd-parent
	> a.toolbar-trigger:after,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li#color-picker-control.toolbar-splitbutton.disabled:hover
	> .aui-dd-parent
	> a.toolbar-trigger:after,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li#color-picker-control.toolbar-splitbutton.disabled:hover
	> a.toolbar-trigger
	.aui-icon:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li#color-picker-control.toolbar-splitbutton.disabled:hover
	> a.toolbar-trigger
	.aui-icon:before {
	color: var(--ds-icon-selected, #405070);
	background-color: var(--ds-background-input, #ffffff);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li#color-picker-control.toolbar-splitbutton:hover
	> .aui-dd-parent
	> a.toolbar-trigger:after,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li#color-picker-control.toolbar-splitbutton:hover
	> .aui-dd-parent
	> a.toolbar-trigger:after {
	color: var(--ds-text-inverse, #ffffff);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li#color-picker-control.toolbar-splitbutton:hover
	> .aui-dd-parent,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li#color-picker-control.toolbar-splitbutton:hover
	> .aui-dd-parent,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li#color-picker-control.toolbar-splitbutton:hover
	> .aui-dd-parent:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li#color-picker-control.toolbar-splitbutton:hover
	> .aui-dd-parent:hover {
	margin-right: 1px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.toolbar-dropdown.disabled
	.dd-allocated:hover
	.toolbar-trigger
	.icon.aui-icon-small:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.toolbar-dropdown.disabled
	.dd-allocated:hover
	.toolbar-trigger
	.icon.aui-icon-small:before {
	color: var(--ds-icon-selected, #405070);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li#more-menu
	.active
	a#rte-button-more.toolbar-trigger.aui-dd-trigger.aui-button,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	li#more-menu
	.active
	a#rte-button-more.toolbar-trigger.aui-dd-trigger.aui-button {
	margin-left: 0;
}

.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons li.toolbar-item,
#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons li.toolbar-item,
.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons li.toolbar-item a.aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons li.toolbar-item a.aui-button {
	height: 24px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons.rte-toolbar-group-formatting,
#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons.rte-toolbar-group-formatting,
.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons.rte-toolbar-group-task-lists,
#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons.rte-toolbar-group-task-lists {
	border-left: none;
}

.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons.rte-toolbar-group-lists,
#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons.rte-toolbar-group-lists {
	margin-right: 0;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.disabled
	.aui-button:hover
	.aui-icon-small:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.disabled
	.aui-button:hover
	.aui-icon-small:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.disabled
	.aui-button:hover
	.aui-icon-large:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.disabled
	.aui-button:hover
	.aui-icon-large:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.disabled
	.aui-button:hover
	.icon-close:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.disabled
	.aui-button:hover
	.icon-close:before {
	color: var(--ds-icon-selected, #405070);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.disabled
	.active.aui-button:hover
	.aui-icon-small:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.disabled
	.active.aui-button:hover
	.aui-icon-small:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.disabled
	.active.aui-button:hover
	.aui-icon-large:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.disabled
	.active.aui-button:hover
	.aui-icon-large:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.disabled
	.active.aui-button:hover
	.icon-close:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.disabled
	.active.aui-button:hover
	.icon-close:before {
	color: var(--ds-icon-inverse, #ffffff);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	> .aui-buttons
	> button.aui-button:not(.aui-dd-trigger),
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	> .aui-buttons
	> button.aui-button:not(.aui-dd-trigger) {
	background: none;
	border: none;
	margin-top: 0;
	outline: none;
	color: var(--ds-text-subtle, #405070);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	> .aui-buttons
	> button.aui-button:not(.aui-dd-trigger):active,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-contextual
	> .aui-buttons
	> button.aui-button:not(.aui-dd-trigger):active {
	background: var(--ds-background-neutral-pressed, rgba(179, 212, 255, 0.6));
	color: var(--ds-text-brand, #0052cc);
	box-shadow: none;
	/*
     Make toolbar buttons 'subtle' - we use an ID to be more specific than AUI's rules for 'normal' buttons.
     */
}

.editor-container.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button,
.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger,
.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton > #rte-button-color,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton > #rte-button-color,
.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-cancel.shared-drafts,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-cancel.shared-drafts,
.editor-container.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent {
	background: 0 0;
	border-color: transparent;
	border-radius: 2px;
	color: var(--ds-surface, #ffffff);
	margin-right: 2px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button:hover,
.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger:hover,
.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton > #rte-button-color:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton > #rte-button-color:hover,
.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-cancel.shared-drafts:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-cancel.shared-drafts:hover,
.editor-container.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent:hover {
	/*
     AUI buttons in the same group have a left margin applied on hover so that the button doesn't
     change its position when a border is rendered - now that we're faking 'subtle' button
     styling we want to prevent this behaviour and override it with a margin of 0
     */
	/* margin-left: 0; */
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button:hover:not(.disabled):not(.active),
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button:hover:not(.disabled):not(.active),
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-trigger.aui-button:hover:not(.disabled):not(.active),
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-trigger.aui-button:hover:not(.disabled):not(.active),
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger:hover:not(.disabled):not(.active),
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger:hover:not(.disabled):not(.active),
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color:hover:not(.disabled):not(.active),
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color:hover:not(.disabled):not(.active),
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts:hover:not(.disabled):not(.active),
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts:hover:not(.disabled):not(.active),
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.aui-dd-parent:hover:not(.disabled):not(.active),
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.aui-dd-parent:hover:not(.disabled):not(.active) {
	background-color: var(--ds-background-input, rgba(9, 30, 66, 0.08));
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button:active:not(.disabled):not(.active),
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button:active:not(.disabled):not(.active),
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-trigger.aui-button:active:not(.disabled):not(.active),
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-trigger.aui-button:active:not(.disabled):not(.active),
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger:active:not(.disabled):not(.active),
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger:active:not(.disabled):not(.active),
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color:active:not(.disabled):not(.active),
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color:active:not(.disabled):not(.active),
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts:active:not(.disabled):not(.active),
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts:active:not(.disabled):not(.active),
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.aui-dd-parent:active:not(.disabled):not(.active),
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.aui-dd-parent:active:not(.disabled):not(.active) {
	background: var(--ds-background-neutral-pressed, rgba(179, 212, 255, 0.6));
	color: var(--ds-text-brand, #0052cc);
	box-shadow: none;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button:active:not(.disabled):not(.active)
	.aui-iconfont-dropdown,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button:active:not(.disabled):not(.active)
	.aui-iconfont-dropdown,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-trigger.aui-button:active:not(.disabled):not(.active)
	.aui-iconfont-dropdown,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-trigger.aui-button:active:not(.disabled):not(.active)
	.aui-iconfont-dropdown,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger:active:not(.disabled):not(.active)
	.aui-iconfont-dropdown,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger:active:not(.disabled):not(.active)
	.aui-iconfont-dropdown,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color:active:not(.disabled):not(.active)
	.aui-iconfont-dropdown,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color:active:not(.disabled):not(.active)
	.aui-iconfont-dropdown,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts:active:not(.disabled):not(.active)
	.aui-iconfont-dropdown,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts:active:not(.disabled):not(.active)
	.aui-iconfont-dropdown,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.aui-dd-parent:active:not(.disabled):not(.active)
	.aui-iconfont-dropdown,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.aui-dd-parent:active:not(.disabled):not(.active)
	.aui-iconfont-dropdown,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button:active:not(.disabled):not(.active)
	a.aui-dd-trigger:after,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button:active:not(.disabled):not(.active)
	a.aui-dd-trigger:after,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-trigger.aui-button:active:not(.disabled):not(.active)
	a.aui-dd-trigger:after,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-trigger.aui-button:active:not(.disabled):not(.active)
	a.aui-dd-trigger:after,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger:active:not(.disabled):not(.active)
	a.aui-dd-trigger:after,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger:active:not(.disabled):not(.active)
	a.aui-dd-trigger:after,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color:active:not(.disabled):not(.active)
	a.aui-dd-trigger:after,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color:active:not(.disabled):not(.active)
	a.aui-dd-trigger:after,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts:active:not(.disabled):not(.active)
	a.aui-dd-trigger:after,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts:active:not(.disabled):not(.active)
	a.aui-dd-trigger:after,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.aui-dd-parent:active:not(.disabled):not(.active)
	a.aui-dd-trigger:after,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.aui-dd-parent:active:not(.disabled):not(.active)
	a.aui-dd-trigger:after {
	color: var(--ds-text-brand, #0052cc);
	border-top-color: var(--ds-border-brand, #0052cc);
}

.editor-container.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button.active,
#content.edit.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button.active,
.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button.active,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button.active,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger.active,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger.active,
.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton > #rte-button-color.active,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton > #rte-button-color.active,
.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-cancel.shared-drafts.active,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-cancel.shared-drafts.active,
.editor-container.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent.active,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent.active,
.editor-container.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button.active .aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button.active .aui-button,
.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button.active .aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button.active .aui-button,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger.active
	.aui-button,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger.active
	.aui-button,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color.active
	.aui-button,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color.active
	.aui-button,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts.active
	.aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-cancel.shared-drafts.active .aui-button,
.editor-container.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent.active .aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent.active .aui-button,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button.active
	.aui-button:hover,
#content.edit.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button.active .aui-button:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-trigger.aui-button.active
	.aui-button:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-trigger.aui-button.active
	.aui-button:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger.active
	.aui-button:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger.active
	.aui-button:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color.active
	.aui-button:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color.active
	.aui-button:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts.active
	.aui-button:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts.active
	.aui-button:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.aui-dd-parent.active
	.aui-button:hover,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.aui-dd-parent.active
	.aui-button:hover {
	border-color: var(--ds-border-focused, #42526e);
	background-color: var(--ds-background-brand-bold-hovered, #42526e);
	color: var(--ds-text-subtle, #405070);
	box-shadow: none;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button.active
	.aui-icon-small:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button.active
	.aui-icon-small:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-trigger.aui-button.active
	.aui-icon-small:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-trigger.aui-button.active
	.aui-icon-small:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger.active
	.aui-icon-small:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger.active
	.aui-icon-small:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color.active
	.aui-icon-small:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color.active
	.aui-icon-small:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts.active
	.aui-icon-small:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts.active
	.aui-icon-small:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.aui-dd-parent.active
	.aui-icon-small:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.aui-dd-parent.active
	.aui-icon-small:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button.active
	.aui-icon-large:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button.active
	.aui-icon-large:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-trigger.aui-button.active
	.aui-icon-large:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-trigger.aui-button.active
	.aui-icon-large:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger.active
	.aui-icon-large:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> .aui-dd-parent
	> .toolbar-trigger.active
	.aui-icon-large:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color.active
	.aui-icon-large:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-splitbutton
	> #rte-button-color.active
	.aui-icon-large:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts.active
	.aui-icon-large:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-button-cancel.shared-drafts.active
	.aui-icon-large:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.aui-dd-parent.active
	.aui-icon-large:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-buttons
	.aui-dd-parent.active
	.aui-icon-large:before {
	color: var(--ds-icon-inverse, #ffffff);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button.disabled:hover
	.aui-icon-small:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button.disabled:hover
	.aui-icon-small:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button.disabled:hover
	.aui-icon-large:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button.disabled:hover
	.aui-icon-large:before {
	color: var(--ds-icon-selected, #405070);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button.disabled.active:hover
	.aui-icon-small:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button.disabled.active:hover
	.aui-icon-small:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button.disabled.active:hover
	.aui-icon-large:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	li.toolbar-item.aui-button.disabled.active:hover
	.aui-icon-large:before {
	color: var(--ds-icon-inverse, #ffffff);
	/* sections */
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-split.toolbar-contextual
	> .aui-buttons
	> button.aui-button
	> .trigger-text,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-split.toolbar-contextual
	> .aui-buttons
	> button.aui-button
	> .trigger-text {
	position: relative;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-split.toolbar-contextual
	> .aui-buttons
	> button.aui-button.disabled:hover
	> .trigger-text,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-split.toolbar-contextual
	> .aui-buttons
	> button.aui-button.disabled:hover
	> .trigger-text {
	color: var(--ds-text-subtle, #405070);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-split.toolbar-contextual
	> .aui-buttons
	> button.aui-button.disabled,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-split.toolbar-contextual
	> .aui-buttons
	> button.aui-button.disabled {
	opacity: 0.5;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	ul.aui-buttons.rte-toolbar-group-table
	#table-picker-container,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	ul.aui-buttons.rte-toolbar-group-table
	#table-picker-container,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	ul.aui-buttons.rte-toolbar-group-table
	#table-picker-container
	.table-picker-box,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	ul.aui-buttons.rte-toolbar-group-table
	#table-picker-container
	.table-picker-box {
	border-radius: 5px;
	margin: 6px 0 20px 0;
	border: solid 1px var(--ds-border-inverse, #eff1ef);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	ul.aui-buttons.rte-toolbar-group-table
	#table-picker-container
	.table-picker-box,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	ul.aui-buttons.rte-toolbar-group-table
	#table-picker-container
	.table-picker-box {
	border: none;
	padding: 1px 6px 1px 6px;
	margin: 6px 0 13px 0;
}

.editor-container.adg3-editor #toolbar #rte-toolbar li.toolbar-item:active,
#content.edit.adg3-editor #toolbar #rte-toolbar li.toolbar-item:active {
	background: var(--ds-background-neutral-pressed, rgba(179, 212, 255, 0.6));
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#format-dropdown.active
	#format-dropdown-display:after,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#format-dropdown.active
	#format-dropdown-display:after {
	border-top-color: var(--ds-border-inverse, #ffffff);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#format-dropdown.active
	#format-dropdown-display
	span.dropdown-text,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#format-dropdown.active
	#format-dropdown-display
	span.dropdown-text {
	color: var(--ds-text-inverse, #ffffff);
}

.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown #format-dropdown-display,
#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown #format-dropdown-display {
	padding: 0 10px 0 10px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#format-dropdown
	#format-dropdown-display
	.dropdown-text,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#format-dropdown
	#format-dropdown-display
	.dropdown-text {
	font-size: 14px;
	min-width: 70px;
	/* covers maximum expected i18n text width to avoid drop down flickering */
	color: var(--ds-text-subtle, #405070);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#format-dropdown
	#format-dropdown-display:active
	.dropdown-text,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#format-dropdown
	#format-dropdown-display:active
	.dropdown-text {
	color: var(--ds-text-brand, #0052cc);
}

.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown li,
#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown li {
	height: 32px;
	padding: 0;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown a,
#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown a {
	padding: 6px 50px 6px 10px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h1 a,
#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h1 a,
.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h2 a,
#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h2 a,
.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h3 a,
#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h3 a,
.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h4 a,
#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h4 a {
	padding: 0.4em 50px 0.5em 10px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar span.icon-close:before,
#content.edit.adg3-editor #toolbar #rte-toolbar span.icon-close:before {
	content: '\\f11b';
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	.aui-buttons
	button.aui-button,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	.aui-buttons
	button.aui-button {
	height: 24px;
	padding: 4px 8px 4px 4px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	.aui-buttons
	button.aui-button
	span.aui-icon,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	.aui-buttons
	button.aui-button
	span.aui-icon {
	margin-top: -4px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	.aui-buttons
	button.aui-button
	span.aui-icon:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	.aui-buttons
	button.aui-button
	span.aui-icon:before {
	margin-left: -2px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	.aui-buttons
	button.aui-button[data-tooltip='Close toolbar'],
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	.aui-buttons
	button.aui-button[data-tooltip='Close toolbar'] {
	padding-right: 4px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	#pagelayout2-toolbar.aui-buttons
	button.aui-button,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	#pagelayout2-toolbar.aui-buttons
	button.aui-button {
	height: 24px;
	padding: 4px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	#pagelayout2-toolbar.aui-buttons
	button.aui-button
	span.aui-icon-small,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	#pagelayout2-toolbar.aui-buttons
	button.aui-button
	span.aui-icon-small {
	margin-top: -8px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	#pagelayout2-toolbar.aui-buttons
	button.aui-button
	span.aui-icon-small:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-pl2-toolbar.toolbar-contextual
	#pagelayout2-toolbar.aui-buttons
	button.aui-button
	span.aui-icon-small:before {
	margin-left: -2px;
	/* icon-only buttons */
}

.editor-container.adg3-editor #toolbar #rte-toolbar .icon,
#content.edit.adg3-editor #toolbar #rte-toolbar .icon {
	text-indent: -9999em;
	width: 16px;
	display: inline-block;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #table-picker-container,
#content.edit.adg3-editor #toolbar #rte-toolbar #table-picker-container {
	position: absolute;
	z-index: 10001;
	background: var(--ds-background-input, #ffffff);
	/* Styles for colour selection in the dropdown */
}

.editor-container.adg3-editor #toolbar #rte-toolbar div.color-picker,
#content.edit.adg3-editor #toolbar #rte-toolbar div.color-picker {
	left: -11px;
	/* align with the colour button, and not the drop-down trigger */
	position: absolute;
	overflow: auto;
	padding: 6px;
	width: 160px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar div.color-picker ul,
#content.edit.adg3-editor #toolbar #rte-toolbar div.color-picker ul {
	list-style: none;
	margin: 0;
	padding: 0;
}

.editor-container.adg3-editor #toolbar #rte-toolbar div.color-picker ul li,
#content.edit.adg3-editor #toolbar #rte-toolbar div.color-picker ul li {
	display: inline;
	float: left;
	height: 16px;
	line-height: 16px;
	padding: 2px;
	width: 16px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar div.color-picker ul li a,
#content.edit.adg3-editor #toolbar #rte-toolbar div.color-picker ul li a {
	border: 1px solid var(--ds-border-bold, #ddd);
	border-radius: 2px;
	display: block;
	height: 14px;
	line-height: 14px;
	padding: 0px;
	text-align: justify;
	width: 14px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #page-layout-2-group,
#content.edit.adg3-editor #toolbar #rte-toolbar #page-layout-2-group {
	margin-right: 0px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar ul.rte-toolbar-group-insert,
#content.edit.adg3-editor #toolbar #rte-toolbar ul.rte-toolbar-group-insert {
	margin-left: -1px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar ul.rte-toolbar-group-task-lists,
#content.edit.adg3-editor #toolbar #rte-toolbar ul.rte-toolbar-group-task-lists {
	padding-left: 0;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons
	.aui-button
	.aui-iconfont-table-merge:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons
	.aui-button
	.aui-iconfont-table-merge:before {
	content: '\\f19d';
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons
	.aui-button
	.aui-iconfont-table-split:before,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons
	.aui-button
	.aui-iconfont-table-split:before {
	content: '\\f1a4';
	/*
     The formatting toolbar needs special overrides because its markup differs from the other dropdowns
     in the toolbar, and its appearance should match the ADG guidelines for texts (rather than icons).
     */
}

.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown #format-dropdown-display,
#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown #format-dropdown-display {
	color: var(--ds-text, #333);
}

.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown.active .aui-button,
#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown.active .aui-button {
	border-color: var(--ds-border-focused, #405070);
	color: var(--ds-text-inverse, #ffffff);
	background-color: var(--ds-background-brand-bold-hovered, #405070);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#format-dropdown.disabled
	#format-dropdown-display:hover
	.dropdown-text,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	#format-dropdown.disabled
	#format-dropdown-display:hover
	.dropdown-text {
	color: var(--ds-text-subtle, #405070);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#format-dropdown.active
	#format-dropdown-display,
#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown.active #format-dropdown-display {
	color: var(--ds-text-inverse, #fff);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-dropdown
	.aui-dropdown
	li.dropdown-item.active,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-dropdown
	.aui-dropdown
	li.dropdown-item.active {
	background: none;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-dropdown
	.aui-dropdown
	li.dropdown-item.active
	a,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-dropdown
	.aui-dropdown
	li.dropdown-item.active
	a {
	background-color: var(--ds-background-input, rgba(9, 30, 66, 0.08));
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-dropdown
	.aui-dropdown
	li.dropdown-item.active:active
	a,
#content.edit.adg3-editor
	#toolbar
	#rte-toolbar
	.toolbar-dropdown
	.aui-dropdown
	li.dropdown-item.active:active
	a {
	background: var(--ds-background-neutral-pressed, rgba(179, 212, 255, 0.6));
	color: var(--ds-text-brand, #0052cc);
}

@media only screen and (max-width: 1024px) {
	/* AUI 6.1.4 specific CSS */
	.editor-container.adg3-editor .contenteditor #draft-status,
	#content.edit.adg3-editor .contenteditor #draft-status {
		display: none !important;
	}
}

body[data-aui-version='6.1.4-SNAPSHOT'] .aui-buttons .aui-button ~ .aui-button:hover,
body[data-aui-version='6.1.4-SNAPSHOT'] .aui-buttons .aui-button ~ .aui-button:focus,
body[data-aui-version='6.1.4-SNAPSHOT'] .aui-buttons .aui-button ~ .aui-button:active {
	margin-left: 0;
	/* AUI 7 & 8 specific CSS */
}

body[data-aui-version^='7'] #rte-toolbar .toolbar-dropdown .aui-dropdown li.dropdown-item.active a,
body[data-aui-version^='8'] #rte-toolbar .toolbar-dropdown .aui-dropdown li.dropdown-item.active a {
	color: var(--ds-text, #333);
}

body[data-aui-version^='7'] #rte-toolbar div.color-picker ul li,
body[data-aui-version^='8'] #rte-toolbar div.color-picker ul li {
	margin-top: 4px;
}

.panel_wrapper div.current {
	height: 245px;
}

.advfield {
	width: 200px;
}

#class {
	width: 150px;
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/adg3-styles/editor-toolbar.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;;CAEC,kBAAkB;AACnB;;AAEA;;;;;;;;;;CAUC,6DAA6D;CAC7D,2BAA2B;AAC5B;;AAEA;;CAEC,mDAAmD;AACpD;;AAEA;;;;;;;;;;CAUC,cAAc;AACf;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;;CAEC,SAAS;CACT,cAAc;AACf;;AAEA;;CAEC,QAAQ;CACR,iBAAiB;AAClB;;AAEA;;CAEC,UAAU;AACX;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,QAAQ;CACR,iBAAiB;AAClB;;AAEA;;CAEC,SAAS;CACT,cAAc;AACf;;AAEA;;CAEC,QAAQ;CACR,iBAAiB;AAClB;;AAEA;;;;;;;;;;CAUC,aAAa;AACd;;AAEA;;;;;;;;;;CAUC,WAAW;CACX,cAAc;CACd,gBAAgB;AACjB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;;;;;;;;;;;;CAYC,oBAAoB;CACpB,UAAU;AACX;;AAEA;;CAEC,yDAAyD;CACzD,YAAY;CACZ,cAAc;AACf;;AAEA;;;;;;CAMC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;;CAEC,qCAAqC;CACrC,oBAAoB;CACpB,YAAY;CACZ,WAAW;AACZ;;AAEA;;CAEC,mDAAmD;CACnD,UAAU;CACV,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,iBAAiB;AAClB;;AAEA;;;;CAIC,iBAAiB;CACjB,oBAAoB;CACpB,mDAAmD;CACnD,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;AACb;;AAEA;;;;CAIC,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAmEC,eAAe;AAChB;;AAEA;;CAEC,gBAAgB;CAChB,iBAAiB;CACjB,aAAa;CACb,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;;CAEC,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;;CAEC,gBAAgB;CAChB,mGAAmG;CACnG,yCAAyC;AAC1C;;AAEA;;CAEC,UAAU;CACV,SAAS;AACV;;AAEA;;CAEC,gDAAgD;AACjD;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;CA0BC,uFAAuF;CACvF,aAAa;CACb,gBAAgB;CAChB,cAAc;CACd,oEAAoE;CACpE,0CAA0C;CAC1C,aAAa;CACb,SAAS;CACT,UAAU;CACV;;;;;qBAKoB;CACpB;;;;;qBAKoB;CACpB;;;;;qBAKoB;AACrB;;AAEA;;CAEC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,qBAAqB;CACrB,cAAc;CACd,gBAAgB;CAChB,UAAU;CACV,cAAc;CACd,0CAA0C;CAC1C,+CAA+C;CAC/C;;;;;sBAKqB;CACrB;;;;;sBAKqB;CACrB;;;;;sBAKqB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;CAoBC,kBAAkB;CAClB,WAAW;CACX,QAAQ;AACT;;AAEA;;;;;;;CAOC,SAAS;CACT,gBAAgB;CAChB,UAAU;CACV,eAAe;CACf,YAAY;AACb;;AAEA;;;;;;;;;;;;;;CAcC,qCAAqC;AACtC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA8BC,eAAe;AAChB;;AAEA;;;;;;;;;;;;CAYC,YAAY;CACZ,WAAW;AACZ;;AAEA;;;;;;;;;;;;CAYC,SAAS;AACV;;AAEA;;;;;;;;;;;;;;;;;;;;CAoBC,QAAQ;CACR,kBAAkB;AACnB;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;;;;;CAKC,kBAAkB;AACnB;;AAEA;;;;;;;;;;CAUC,WAAW;AACZ;;AAEA;;CAEC,qBAAqB;CACrB,UAAU;CACV,WAAW;CACX,kBAAkB;AACnB;;AAEA;;;;CAIC,WAAW;AACZ;;AAEA;;;;CAIC,UAAU;CACV,WAAW;AACZ;;AAEA;;;;;;;;CAQC,cAAc;AACf;;AAEA;;;;;;;;;;;;CAYC,gBAAgB;CAChB,aAAa;CACb,cAAc;AACf;;AAEA;;;;;;;;CAQC,kBAAkB;CAClB,UAAU;CACV,WAAW;AACZ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,WAAW;CACX,SAAS;AACV;;AAEA;;;;;;;;CAQC,WAAW;AACZ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAgCC,WAAW;CACX,kBAAkB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAwCC,SAAS;CACT,kBAAkB;AACnB;;AAEA;;CAEC,WAAW;AACZ;;AAEA;;;;CAIC,UAAU;CACV,kBAAkB;AACnB;;AAEA;;;;;;;;;;;;;;;;CAgBC,kEAAkE;CAClE,sBAAsB;CACtB,mCAAmC;AACpC;;AAEA;;;;;;;;;;;;;;;;CAgBC,gDAAgD;AACjD;;AAEA;;CAEC,YAAY;CACZ,gBAAgB;CAChB,aAAa;AACd;;AAEA;;CAEC,0EAA0E;CAC1E,sCAAsC;CACtC,gBAAgB;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4BC,iBAAiB;AAClB;;AAEA;;;;;;;;;;;;;;CAcC,gBAAgB;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,mGAAmG;CACnG,yCAAyC;AAC1C;;AAEA;;CAEC,6DAA6D;AAC9D;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;CA0BC,iBAAiB;CACjB,eAAe;CACf,wBAAwB;AACzB;;AAEA;;CAEC,gBAAgB;CAChB,SAAS;CACT,cAAc;AACf;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;;;;;;;;;;;;;;;;CAgBC,uCAAuC;CACvC,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;;;;;;;;;;CAUC,8BAA8B;CAC9B,UAAU;AACX;;AAEA;;;;;;;;;;;;;;;;CAgBC,0BAA0B;CAC1B,UAAU;AACX;;AAEA;;;;;;;;;;;;;;CAcC,gBAAgB;AACjB;;AAEA;;;;;;CAMC,eAAe;CACf;;MAEK;AACN;;AAEA;;CAEC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,qBAAqB;CACrB,YAAY;CACZ,WAAW;AACZ;;AAEA;;CAEC,gBAAgB;CAChB,QAAQ;CACR,SAAS;CACT,gBAAgB;CAChB,YAAY;CACZ,UAAU;CACV,WAAW;CACX,WAAW;CACX,YAAY;AACb;;AAEA;;;;;;;;;;;;CAYC,YAAY;CACZ,UAAU;CACV,4DAA4D;CAC5D,cAAc;CACd,cAAc;AACf;;AAEA;;;;;;;;;;;;CAYC,WAAW;CACX,WAAW;CACX,WAAW;CACX,4DAA4D;CAC5D,sBAAsB;CACtB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;;CAEC,mEAAmE;CACnE,kBAAkB;CAClB;;;;MAIK;AACN;;AAEA;;CAEC,YAAY;AACb;;AAEA;;;;;;CAMC,YAAY;CACZ,4BAA4B;AAC7B;;AAEA;;;;;;;CAOC,iBAAiB;CACjB,8BAA8B;AAC/B;;AAEA;;;;;;;;;;;;CAYC,mEAAmE;CACnE,kBAAkB;AACnB;;AAEA;;;;;;;;;;;;CAYC,qCAAqC;AACtC;;AAEA;;;;;;;;;;;;CAYC,sCAAsC;AACvC;;AAEA;;;;;;;;;;;;CAYC,qDAAqD;CACrD,qCAAqC;CACrC,mBAAmB;CACnB,YAAY;AACb;;AAEA;;;;;;;;;;;;;;CAcC,uCAAuC;AACxC;;AAEA;;;;;;;;;;;;;;CAcC,SAAS;CACT,UAAU;AACX;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAgHC,cAAc;AACf;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAwCC,uCAAuC;CACvC,qDAAqD;AACtD;;AAEA;;;;;;;;;;;;;;CAcC,sCAAsC;AACvC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,iBAAiB;AAClB;;AAEA;;;;;;;;;;;;;;;;CAgBC,uCAAuC;AACxC;;AAEA;;;;;;;;;;;;;;CAcC,cAAc;AACf;;AAEA;;;;CAIC,YAAY;AACb;;AAEA;;;;CAIC,iBAAiB;AAClB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA0CC,uCAAuC;AACxC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA0CC,sCAAsC;AACvC;;AAEA;;;;;;;;;;;;CAYC,gBAAgB;CAChB,YAAY;CACZ,aAAa;CACb,aAAa;CACb,qCAAqC;AACtC;;AAEA;;;;;;;;;;;;CAYC,0EAA0E;CAC1E,oCAAoC;CACpC,gBAAgB;CAChB;;MAEK;AACN;;AAEA;;;;;;;;;;;;;;;;;;;;;;CAsBC,eAAe;CACf,yBAAyB;CACzB,kBAAkB;CAClB,iCAAiC;CACjC,iBAAiB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;CAsBC;;;;MAIK;CACL,oBAAoB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAwDC,mEAAmE;AACpE;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAwDC,0EAA0E;CAC1E,oCAAoC;CACpC,gBAAgB;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAwIC,oCAAoC;CACpC,iDAAiD;AAClD;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4HC,+CAA+C;CAC/C,kEAAkE;CAClE,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAwIC,sCAAsC;AACvC;;AAEA;;;;;;;;;;;;;;;;;;;;CAoBC,uCAAuC;AACxC;;AAEA;;;;;;;;;;;;;;;;;;;;CAoBC,sCAAsC;CACtC,aAAa;AACd;;AAEA;;;;;;;;;;;;;;CAcC,kBAAkB;AACnB;;AAEA;;;;;;;;;;;;;;CAcC,qCAAqC;AACtC;;AAEA;;;;;;;;;;;;CAYC,YAAY;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;CAsBC,kBAAkB;CAClB,oBAAoB;CACpB,mDAAmD;AACpD;;AAEA;;;;;;;;;;;;CAYC,YAAY;CACZ,wBAAwB;CACxB,oBAAoB;AACrB;;AAEA;;CAEC,0EAA0E;AAC3E;;AAEA;;;;;;;;;;CAUC,mDAAmD;AACpD;;AAEA;;;;;;;;;;;;CAYC,sCAAsC;AACvC;;AAEA;;CAEC,sBAAsB;AACvB;;AAEA;;;;;;;;;;;;CAYC,eAAe;CACf,eAAe;CACf,0EAA0E;CAC1E,qCAAqC;AACtC;;AAEA;;;;;;;;;;;;CAYC,oCAAoC;AACrC;;AAEA;;CAEC,YAAY;CACZ,UAAU;AACX;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;;;;;;;;CAQC,8BAA8B;AAC/B;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;;;;;;;;;;;;CAYC,YAAY;CACZ,wBAAwB;AACzB;;AAEA;;;;;;;;;;;;;;CAcC,gBAAgB;AACjB;;AAEA;;;;;;;;;;;;;;CAcC,iBAAiB;AAClB;;AAEA;;;;;;;;;;;;CAYC,kBAAkB;AACnB;;AAEA;;;;;;;;;;;;CAYC,YAAY;CACZ,YAAY;AACb;;AAEA;;;;;;;;;;;;;;CAcC,gBAAgB;AACjB;;AAEA;;;;;;;;;;;;;;CAcC,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;;CAEC,oBAAoB;CACpB,WAAW;CACX,qBAAqB;AACtB;;AAEA;;CAEC,kBAAkB;CAClB,cAAc;CACd,+CAA+C;CAC/C,gDAAgD;AACjD;;AAEA;;CAEC,WAAW;CACX,gEAAgE;CAChE,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,YAAY;AACb;;AAEA;;CAEC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;;CAEC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,YAAY;CACZ,WAAW;AACZ;;AAEA;;CAEC,6CAA6C;CAC7C,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,iBAAiB;CACjB,YAAY;CACZ,mBAAmB;CACnB,WAAW;AACZ;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;;;;;;;;;;;;;;CAcC,gBAAgB;AACjB;;AAEA;;;;;;;;;;;;;;CAcC,gBAAgB;CAChB;;;MAGK;AACN;;AAEA;;CAEC,2BAA2B;AAC5B;;AAEA;;CAEC,+CAA+C;CAC/C,sCAAsC;CACtC,kEAAkE;AACnE;;AAEA;;;;;;;;;;;;CAYC,qCAAqC;AACtC;;AAEA;;;;;;CAMC,mCAAmC;AACpC;;AAEA;;;;;;;;;;;;CAYC,gBAAgB;AACjB;;AAEA;;;;;;;;;;;;;;CAcC,mEAAmE;AACpE;;AAEA;;;;;;;;;;;;;;CAcC,0EAA0E;CAC1E,oCAAoC;AACrC;;AAEA;CACC,2BAA2B;CAC3B;;EAEC,wBAAwB;CACzB;AACD;;AAEA;;;CAGC,cAAc;CACd,2BAA2B;AAC5B;;AAEA;;CAEC,2BAA2B;AAC5B;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb","sourcesContent":["/* CSS file for table dialog in the table plugin */\n\n.editor-container.adg3-editor #rte-ellipsis-menu.aui-dropdown2.aui-style-default,\n#content.edit.adg3-editor #rte-ellipsis-menu.aui-dropdown2.aui-style-default {\n\tborder-radius: 5px;\n}\n\n.editor-container.adg3-editor\n\t#rte-ellipsis-menu.aui-dropdown2.aui-style-default\n\t.aui-dropdown2-section\n\tli\n\ta:hover,\n#content.edit.adg3-editor\n\t#rte-ellipsis-menu.aui-dropdown2.aui-style-default\n\t.aui-dropdown2-section\n\tli\n\ta:hover {\n\tbackground-color: var(--ds-background-input-hovered, #f2f2f2);\n\tcolor: var(--ds-text, #333);\n}\n\n.editor-container.adg3-editor #toolbar,\n#content.edit.adg3-editor #toolbar {\n\tbackground-color: var(--ds-surface-sunken, #f5f5f5);\n}\n\n.editor-container.adg3-editor #toolbar #rte-button-color,\n#content.edit.adg3-editor #toolbar #rte-button-color,\n.editor-container.adg3-editor #toolbar #rte-button-insert-table,\n#content.edit.adg3-editor #toolbar #rte-button-insert-table,\n.editor-container.adg3-editor #toolbar #rte-button-insert,\n#content.edit.adg3-editor #toolbar #rte-button-insert,\n.editor-container.adg3-editor #toolbar #rte-button-pagelayout,\n#content.edit.adg3-editor #toolbar #rte-button-pagelayout,\n.editor-container.adg3-editor #toolbar #rte-button-insert-template,\n#content.edit.adg3-editor #toolbar #rte-button-insert-template {\n\tpadding: 0 6px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-button-more .icon-dropdown,\n#content.edit.adg3-editor #toolbar #rte-button-more .icon-dropdown {\n\tmargin-left: 3px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-button-pagelayout-2,\n#content.edit.adg3-editor #toolbar #rte-button-pagelayout-2 {\n\tmargin: 0;\n\tpadding: 0 4px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-button-pagelayout-2 .aui-iconfont-editor-layout:before,\n#content.edit.adg3-editor #toolbar #rte-button-pagelayout-2 .aui-iconfont-editor-layout:before {\n\tright: 0;\n\tmargin-left: -3px;\n}\n\n.editor-container.adg3-editor #toolbar #confluence-insert-files,\n#content.edit.adg3-editor #toolbar #confluence-insert-files {\n\tpadding: 0;\n}\n\n.editor-container.adg3-editor #toolbar #confluence-insert-files a.toolbar-trigger,\n#content.edit.adg3-editor #toolbar #confluence-insert-files a.toolbar-trigger {\n\tpadding: 0 4px;\n}\n\n.editor-container.adg3-editor #toolbar #confluence-insert-files .aui-iconfont-editor-files:before,\n#content.edit.adg3-editor #toolbar #confluence-insert-files .aui-iconfont-editor-files:before {\n\tright: 0;\n\tmargin-left: -3px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-button-link,\n#content.edit.adg3-editor #toolbar #rte-button-link {\n\tmargin: 0;\n\tpadding: 0 4px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-button-link .aui-iconfont-link:before,\n#content.edit.adg3-editor #toolbar #rte-button-link .aui-iconfont-link:before {\n\tright: 0;\n\tmargin-left: -3px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-button-link .trigger-text,\n#content.edit.adg3-editor #toolbar #rte-button-link .trigger-text,\n.editor-container.adg3-editor #toolbar #confluence-insert-files > .trigger-text,\n#content.edit.adg3-editor #toolbar #confluence-insert-files > .trigger-text,\n.editor-container.adg3-editor #toolbar #insert-table-dropdown .dropdown-text,\n#content.edit.adg3-editor #toolbar #insert-table-dropdown .dropdown-text,\n.editor-container.adg3-editor #toolbar #insert-menu .dropdown-text,\n#content.edit.adg3-editor #toolbar #insert-menu .dropdown-text,\n.editor-container.adg3-editor #toolbar #rte-button-insert-template .dropdown-text,\n#content.edit.adg3-editor #toolbar #rte-button-insert-template .dropdown-text {\n\tdisplay: none;\n}\n\n.editor-container.adg3-editor #toolbar #confluence-insert-files #rte-button-link .icon-dropdown,\n#content.edit.adg3-editor #toolbar #confluence-insert-files #rte-button-link .icon-dropdown,\n.editor-container.adg3-editor #toolbar #insert-table-dropdown .icon-dropdown,\n#content.edit.adg3-editor #toolbar #insert-table-dropdown .icon-dropdown,\n.editor-container.adg3-editor #toolbar #insert-menu .icon-dropdown,\n#content.edit.adg3-editor #toolbar #insert-menu .icon-dropdown,\n.editor-container.adg3-editor #toolbar #rte-button-pagelayout .icon-dropdown,\n#content.edit.adg3-editor #toolbar #rte-button-pagelayout .icon-dropdown,\n.editor-container.adg3-editor #toolbar #rte-button-insert-template .icon-dropdown,\n#content.edit.adg3-editor #toolbar #rte-button-insert-template .icon-dropdown {\n\twidth: 22px;\n\tmargin-left: 0;\n\tpadding-right: 0;\n}\n\n.editor-container.adg3-editor #toolbar #rte-button-pagelayout .icon-layout,\n#content.edit.adg3-editor #toolbar #rte-button-pagelayout .icon-layout {\n\tmargin-top: 2px;\n}\n\n.editor-container.adg3-editor #toolbar li#insert-table-dropdown,\n#content.edit.adg3-editor #toolbar li#insert-table-dropdown,\n.editor-container.adg3-editor #toolbar #pagelayout-menu,\n#content.edit.adg3-editor #toolbar #pagelayout-menu,\n.editor-container.adg3-editor #toolbar #page-layout-2,\n#content.edit.adg3-editor #toolbar #page-layout-2,\n.editor-container.adg3-editor #toolbar #table-highlight-colour,\n#content.edit.adg3-editor #toolbar #table-highlight-colour,\n.editor-container.adg3-editor #toolbar #format-dropdown,\n#content.edit.adg3-editor #toolbar #format-dropdown,\n.editor-container.adg3-editor #toolbar #template-menu,\n#content.edit.adg3-editor #toolbar #template-menu {\n\t/* template editor */\n\tpadding: 0;\n}\n\n.editor-container.adg3-editor #toolbar #rte-button-cancel.shared-drafts,\n#content.edit.adg3-editor #toolbar #rte-button-cancel.shared-drafts {\n\t/* button.aui-button height is 28px with default styles */\n\theight: 26px;\n\tpadding: 0 6px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar-row-default,\n#content.edit.adg3-editor #toolbar #rte-toolbar-row-default,\n.editor-container.adg3-editor #toolbar #rte-toolbar-row-pl2-toolbar,\n#content.edit.adg3-editor #toolbar #rte-toolbar-row-pl2-toolbar,\n.editor-container.adg3-editor #toolbar #rte-toolbar-row-searchreplace,\n#content.edit.adg3-editor #toolbar #rte-toolbar-row-searchreplace {\n\theight: 35px;\n\tpadding-top: 10px;\n}\n\n.editor-container.adg3-editor #toolbar #adg3-charlie-icon svg,\n#content.edit.adg3-editor #toolbar #adg3-charlie-icon svg {\n\tcolor: var(--ds-icon-subtle, #cccccc);\n\tmargin: 0 8px 0 10px;\n\theight: 24px;\n\twidth: 24px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar,\n#content.edit.adg3-editor #toolbar #rte-toolbar {\n\tbackground-color: var(--ds-surface-sunken, #f5f5f5);\n\tz-index: 2;\n\tposition: relative;\n\theight: 100%;\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-primary,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-primary,\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual {\n\tpadding-top: 26px;\n\tpadding-bottom: 26px;\n\tbackground-color: var(--ds-surface-sunken, #f5f5f5);\n\tmargin-right: 0px;\n\tpadding-right: 0px;\n\tflex-grow: 1;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-primary .aui-buttons.no-separator,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-primary .aui-buttons.no-separator,\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons.no-separator,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons.no-separator {\n\tmargin-right: 0px;\n\tmargin-left: 0px;\n\tpadding: 0 1px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar2-primary\n\t.aui-buttons\n\t.aui-button:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar2-primary\n\t.aui-buttons\n\t.aui-button:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\t.aui-button:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons .aui-button:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar2-primary\n\t.aui-buttons\n\t.toolbar-item:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar2-primary\n\t.aui-buttons\n\t.toolbar-item:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\t.toolbar-item:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\t.toolbar-item:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar2-primary\n\t.aui-buttons\n\t.toolbar-trigger:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar2-primary\n\t.aui-buttons\n\t.toolbar-trigger:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\t.toolbar-trigger:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\t.toolbar-trigger:hover {\n\tcursor: pointer;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary {\n\tposition: static;\n\tpadding-top: 25px;\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\tmargin-right: 5px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-dd-parent a.aui-dd-trigger,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-dd-parent a.aui-dd-trigger {\n\tposition: relative;\n\tline-height: 24px;\n\tfont-size: 12px;\n\tborder-radius: 3px;\n\ttext-shadow: none;\n\ttext-decoration: none;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-dd-parent a.aui-dd-trigger:after,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-dd-parent a.aui-dd-trigger:after {\n\tmargin-top: -3px;\n\t/* Using icon as a border color because this :after is for the triangle caret icons in the button */\n\tborder-top-color: var(--ds-icon, #405070);\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-dd-parent a#rte-button-color,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-dd-parent a#rte-button-color {\n\tpadding: 0;\n\tmargin: 0;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-dd-parent.active > a.aui-dd-trigger:after,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-dd-parent.active > a.aui-dd-trigger:after {\n\tborder-top-color: var(--ds-border-inverse, #fff);\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual.disabled,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual.disabled,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-pl2-toolbar.disabled,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-pl2-toolbar.disabled,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-default.disabled,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-default.disabled,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-searchreplace.disabled,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-searchreplace.disabled {\n\t/* Make invisible, we can't beat an inline display block, so we shrink the height to 0*/\n\tmin-height: 0;\n\toverflow: hidden;\n\tpadding-top: 0;\n\tborder-bottom: 1px solid var(--ds-border-disabled, rgba(0, 0, 0, 0));\n\tbackground-color: var(--ds-surface, white);\n\tmin-height: 0;\n\theight: 0;\n\topacity: 0;\n\t-webkit-transition:\n\t\tmin-height 0.35s ease,\n\t\theight 0.35s ease,\n\t\tpadding 0.1s ease,\n\t\topacity 0.5s ease-out,\n\t\tborder 0.75s linear;\n\t-moz-transition:\n\t\tmin-height 0.35s ease,\n\t\theight 0.35s ease,\n\t\tpadding 0.1s ease,\n\t\topacity 0.5s ease-out,\n\t\tborder 0.75s linear;\n\ttransition:\n\t\tmin-height 0.35s ease,\n\t\theight 0.35s ease,\n\t\tpadding 0.1s ease,\n\t\topacity 0.5s ease-out,\n\t\tborder 0.75s linear;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual {\n\tposition: absolute;\n\ttop: 88px;\n\tleft: 0px;\n\tpadding: 6px 0 0 25px;\n\tmargin-left: 0;\n\tmin-height: 32px;\n\topacity: 1;\n\tdisplay: block;\n\tbackground-color: var(--ds-surface, white);\n\tborder-bottom: 1px solid var(--ds-border, #ccc);\n\t-webkit-transition:\n\t\tmin-height 0.35s ease,\n\t\theight 0.35s ease,\n\t\tpadding 0.1s ease,\n\t\topacity 0.5s ease-in,\n\t\tborder 0.75s ease-in;\n\t-moz-transition:\n\t\tmin-height 0.35s ease,\n\t\theight 0.35s ease,\n\t\tpadding 0.1s ease,\n\t\topacity 0.5s ease-in,\n\t\tborder 0.75s ease-in;\n\ttransition:\n\t\tmin-height 0.35s ease,\n\t\theight 0.35s ease,\n\t\tpadding 0.1s ease,\n\t\topacity 0.5s ease-in,\n\t\tborder 0.75s ease-in;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-searchreplace\n\t.aui-buttons.close,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-searchreplace\n\t.aui-buttons.close,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-pl2-toolbar\n\t.aui-buttons.close,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-pl2-toolbar\n\t.aui-buttons.close {\n\tposition: absolute;\n\tright: 42px;\n\ttop: 8px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons.close\n\t.aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons.close .aui-button {\n\tborder: 0;\n\tbox-shadow: none;\n\tpadding: 0;\n\tmargin-top: 4px;\n\theight: 16px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\t.toolbar-item\n\t> label,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\t.toolbar-item\n\t> label {\n\tcolor: var(--ds-text-subtle, #405070);\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons .aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons .aui-button,\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons a.aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons a.aui-button,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\t.aui-button:visited,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\t.aui-button:visited,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\t.toolbar-item\n\tlabel,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\t.toolbar-item\n\tlabel {\n\tfont-size: 13px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button[data-tooltip='Close'],\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button[data-tooltip='Close'] {\n\theight: 24px;\n\twidth: 24px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button[data-tooltip='Close']:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button[data-tooltip='Close']:before {\n\tleft: 1px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-default\n\t.aui-buttons,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-default\n\t.aui-buttons,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-pl2-toolbar\n\t.aui-buttons,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-pl2-toolbar\n\t.aui-buttons {\n\ttop: 3px;\n\tposition: relative;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual#rte-toolbar-row-pl2-toolbar,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual#rte-toolbar-row-pl2-toolbar {\n\tpadding-left: 32px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-searchreplace,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual#rte-toolbar-row-searchreplace {\n\tpadding-left: 39px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-searchreplace\n\t.aui-buttons.close,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual#rte-toolbar-row-searchreplace\n\t.aui-buttons.close {\n\tright: 47px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar li.aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar li.aui-button {\n\tdisplay: inline-block;\n\tpadding: 0;\n\twidth: 24px;\n\ttext-align: center;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #color-picker-control,\n#content.edit.adg3-editor #toolbar #rte-toolbar #color-picker-control,\n.editor-container.adg3-editor #toolbar #rte-toolbar #more-menu,\n#content.edit.adg3-editor #toolbar #rte-toolbar #more-menu {\n\tfloat: none;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #insert-menu,\n#content.edit.adg3-editor #toolbar #rte-toolbar #insert-menu,\n.editor-container.adg3-editor #toolbar #rte-toolbar #insert-table-dropdown,\n#content.edit.adg3-editor #toolbar #rte-toolbar #insert-table-dropdown {\n\tpadding: 0;\n\twidth: 42px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #insert-menu .aui-dd-parent.active:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar #insert-menu .aui-dd-parent.active:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#insert-table-dropdown\n\t.aui-dd-parent.active:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar #insert-table-dropdown .aui-dd-parent.active:hover {\n\tcolor: inherit;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#insert-menu\n\t#insert-menu-options\n\t.grouped-dropdown-item:last-child,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#insert-menu\n\t#insert-menu-options\n\t.grouped-dropdown-item:last-child {\n\tborder-top: none;\n\tmargin-top: 0;\n\tpadding-top: 0;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar a#rte-button-more,\n#content.edit.adg3-editor #toolbar #rte-toolbar a#rte-button-more,\n.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert-table,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert-table,\n.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert,\n.editor-container.adg3-editor #toolbar #rte-toolbar #color-picker-control,\n#content.edit.adg3-editor #toolbar #rte-toolbar #color-picker-control {\n\tborder-radius: 3px;\n\tpadding: 0;\n\twidth: 42px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar a#rte-button-more .aui-iconfont-add,\n#content.edit.adg3-editor #toolbar #rte-toolbar a#rte-button-more .aui-iconfont-add,\n.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert-table .aui-iconfont-add,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert-table .aui-iconfont-add,\n.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert .aui-iconfont-add,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert .aui-iconfont-add,\n.editor-container.adg3-editor #toolbar #rte-toolbar #color-picker-control .aui-iconfont-add,\n#content.edit.adg3-editor #toolbar #rte-toolbar #color-picker-control .aui-iconfont-add,\n.editor-container.adg3-editor #toolbar #rte-toolbar a#rte-button-more .aui-iconfont-editor-table,\n#content.edit.adg3-editor #toolbar #rte-toolbar a#rte-button-more .aui-iconfont-editor-table,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-insert-table\n\t.aui-iconfont-editor-table,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert-table .aui-iconfont-editor-table,\n.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert .aui-iconfont-editor-table,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert .aui-iconfont-editor-table,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#color-picker-control\n\t.aui-iconfont-editor-table,\n#content.edit.adg3-editor #toolbar #rte-toolbar #color-picker-control .aui-iconfont-editor-table {\n\twidth: 24px;\n\tleft: 6px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar a#rte-button-more .aui-iconfont-dropdown,\n#content.edit.adg3-editor #toolbar #rte-toolbar a#rte-button-more .aui-iconfont-dropdown,\n.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert-table .aui-iconfont-dropdown,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert-table .aui-iconfont-dropdown,\n.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert .aui-iconfont-dropdown,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert .aui-iconfont-dropdown,\n.editor-container.adg3-editor #toolbar #rte-toolbar #color-picker-control .aui-iconfont-dropdown,\n#content.edit.adg3-editor #toolbar #rte-toolbar #color-picker-control .aui-iconfont-dropdown {\n\twidth: 18px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\ta#rte-button-more\n\t.icon.aui-iconfont-editor-styles,\n#content.edit.adg3-editor #toolbar #rte-toolbar a#rte-button-more .icon.aui-iconfont-editor-styles,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-insert-table\n\t.icon.aui-iconfont-editor-styles,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-insert-table\n\t.icon.aui-iconfont-editor-styles,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-insert\n\t.icon.aui-iconfont-editor-styles,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert .icon.aui-iconfont-editor-styles,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#color-picker-control\n\t.icon.aui-iconfont-editor-styles,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#color-picker-control\n\t.icon.aui-iconfont-editor-styles {\n\twidth: 24px;\n\ttext-align: center;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\ta#rte-button-more\n\t.icon.aui-iconfont-editor-styles:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\ta#rte-button-more\n\t.icon.aui-iconfont-editor-styles:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-insert-table\n\t.icon.aui-iconfont-editor-styles:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-insert-table\n\t.icon.aui-iconfont-editor-styles:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-insert\n\t.icon.aui-iconfont-editor-styles:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-insert\n\t.icon.aui-iconfont-editor-styles:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#color-picker-control\n\t.icon.aui-iconfont-editor-styles:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#color-picker-control\n\t.icon.aui-iconfont-editor-styles:before {\n\tleft: 2px;\n\ttext-align: center;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #color-picker-control,\n#content.edit.adg3-editor #toolbar #rte-toolbar #color-picker-control {\n\twidth: 37px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-insert:after,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-insert:after,\n.editor-container.adg3-editor #toolbar #rte-toolbar a#rte-button-more:after,\n#content.edit.adg3-editor #toolbar #rte-toolbar a#rte-button-more:after {\n\tleft: 28px;\n\tmargin: -3px 0 0 0;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons\n\t.toolbar-dropdown.active\n\t.aui-dd-parent\n\ta.toolbar-trigger.aui-dd-trigger.aui-button,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons\n\t.toolbar-dropdown.active\n\t.aui-dd-parent\n\ta.toolbar-trigger.aui-dd-trigger.aui-button {\n\tbackground-color: var(--ds-background-brand-bold-hovered, #405070);\n\tbackground-image: none;\n\tcolor: var(--ds-text-inverse, #fff);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons\n\t.toolbar-dropdown.active\n\t.aui-dd-parent\n\ta.toolbar-trigger.aui-dd-trigger.aui-button:after,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons\n\t.toolbar-dropdown.active\n\t.aui-dd-parent\n\ta.toolbar-trigger.aui-dd-trigger.aui-button:after {\n\tborder-top-color: var(--ds-border-inverse, #fff);\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #rte-toolbar-row-default .aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-toolbar-row-default .aui-button {\n\theight: 24px;\n\tpadding: 0px 4px;\n\toutline: none;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #rte-toolbar-row-default .aui-button:active,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-toolbar-row-default .aui-button:active {\n\tbackground: var(--ds-background-neutral-pressed, rgba(179, 212, 255, 0.6));\n\tcolor: var(--ds-link-pressed, #0052cc);\n\tbox-shadow: none;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons\n\tbutton\n\t.icon.aui-icon-small:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons\n\tbutton\n\t.icon.aui-icon-small:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons\n\tbutton\n\t.icon.aui-icon-large:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons\n\tbutton\n\t.icon.aui-icon-large:before {\n\tmargin-left: -3px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons\n\tbutton\n\t.icon.aui-iconfont-table-header-row:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons\n\tbutton\n\t.icon.aui-iconfont-table-header-row:before {\n\tcontent: '\\f19c';\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-dropdown.disabled\n\t.aui-dd-parent\n\t> a.aui-dd-trigger:hover:after,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-dropdown.disabled\n\t.aui-dd-parent\n\t> a.aui-dd-trigger:hover:after,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton.disabled\n\t.aui-dd-parent\n\t> a.aui-dd-trigger:hover:after,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton.disabled\n\t.aui-dd-parent\n\t> a.aui-dd-trigger:hover:after {\n\t/* Using icon as a border color because this :after is for the triangle caret icons in the button */\n\tborder-top-color: var(--ds-icon, #405070);\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton:hover {\n\tbackground-color: var(--ds-background-input-hovered, #ffffff);\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary .aui-buttons,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary .aui-buttons,\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-buttons.no-separator,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-buttons.no-separator,\n.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons:first-child,\n#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons:first-child,\n.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons:nth-of-type(2),\n#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons:nth-of-type(2),\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons:first-child,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-toolbar-row-default .aui-buttons:first-child,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar\n\t.aui-buttons:first-child,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar\n\t.aui-buttons:first-child,\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-buttons.close,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-buttons.close {\n\tborder-left: none;\n\tpadding-left: 0;\n\t/*Relative resize table*/\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar ul.table-mode-list,\n#content.edit.adg3-editor #toolbar #rte-toolbar ul.table-mode-list {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 5px 0;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar ul.table-mode-list .item-link,\n#content.edit.adg3-editor #toolbar #rte-toolbar ul.table-mode-list .item-link {\n\tpadding-right: 20px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar ul.table-mode-list .dropdown-item,\n#content.edit.adg3-editor #toolbar #rte-toolbar ul.table-mode-list .dropdown-item {\n\tline-height: 18px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-contextual.disabled,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual.disabled,\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-item.disabled,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-item.disabled,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-button[disabled]\n\t.icon,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-button[disabled]\n\t.icon {\n\tcolor: var(--ds-icon-disabled, #707070);\n\topacity: 0.5;\n\tcursor: not-allowed;\n\tborder-bottom: 0;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .disabled a,\n#content.edit.adg3-editor #toolbar #rte-toolbar .disabled a,\n.editor-container.adg3-editor #toolbar #rte-toolbar .disabled span,\n#content.edit.adg3-editor #toolbar #rte-toolbar .disabled span,\n.editor-container.adg3-editor #toolbar #rte-toolbar .disabled button,\n#content.edit.adg3-editor #toolbar #rte-toolbar .disabled button,\n.editor-container.adg3-editor #toolbar #rte-toolbar .disabled div,\n#content.edit.adg3-editor #toolbar #rte-toolbar .disabled div,\n.editor-container.adg3-editor #toolbar #rte-toolbar .disabled li,\n#content.edit.adg3-editor #toolbar #rte-toolbar .disabled li {\n\tcursor: not-allowed !important;\n\topacity: 1;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .disabled#rte-button-help,\n#content.edit.adg3-editor #toolbar #rte-toolbar .disabled#rte-button-help,\n.editor-container.adg3-editor #toolbar #rte-toolbar .disabled#rte-button-help a,\n#content.edit.adg3-editor #toolbar #rte-toolbar .disabled#rte-button-help a,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.disabled#rte-button-help\n\ta\n\t.aui-iconfont-editor-help,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.disabled#rte-button-help\n\ta\n\t.aui-iconfont-editor-help {\n\tcursor: pointer !important;\n\topacity: 1;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t.aui-buttons.close\n\t.aui-button\n\t.aui-iconfont-close-dialog:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t.aui-buttons.close\n\t.aui-button\n\t.aui-iconfont-close-dialog:before {\n\tmargin-top: -2px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar2-secondary\n\tul.aui-buttons:last-child,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary ul.aui-buttons:last-child {\n\tmargin-right: 0;\n\t/*\n     ADG3 invite to edit\n     */\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .adg3InviteToEdit,\n#content.edit.adg3-editor #toolbar #rte-toolbar .adg3InviteToEdit {\n\tposition: relative;\n\ttop: -3px;\n\tleft: -5px;\n\tdisplay: inline-block;\n\theight: 32px;\n\twidth: 32px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .adg3InviteToEdit #inviteToEditLink,\n#content.edit.adg3-editor #toolbar #rte-toolbar .adg3InviteToEdit #inviteToEditLink {\n\tposition: static;\n\tright: 0;\n\tbottom: 0;\n\tbackground: none;\n\tborder: none;\n\tpadding: 0;\n\tmargin: 8px;\n\twidth: 16px;\n\theight: 16px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.adg3InviteToEdit\n\t#inviteToEditLink\n\t.invite-plus-icon,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.adg3InviteToEdit\n\t#inviteToEditLink\n\t.invite-plus-icon {\n\theight: 12px;\n\twidth: 2px;\n\tbackground-color: var(--ds-background-neutral-bold, #707070);\n\tdisplay: block;\n\tmargin: 0 auto;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.adg3InviteToEdit\n\t#inviteToEditLink\n\t.invite-plus-icon:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.adg3InviteToEdit\n\t#inviteToEditLink\n\t.invite-plus-icon:before {\n\tcontent: '';\n\theight: 2px;\n\twidth: 12px;\n\tbackground-color: var(--ds-background-neutral-bold, #707070);\n\tdisplay: table-caption;\n\tmargin-left: -5px;\n\tmargin-top: 5px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .adg3InviteToEdit #inviteToEditLink:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar .adg3InviteToEdit #inviteToEditLink:hover {\n\tbackground-color: var(--ds-background-input, rgba(9, 30, 66, 0.08));\n\tborder-radius: 2px;\n\t/*\n     remove separator\n     - between lists | task list\n     - block formatting\n     */\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons,\n#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons {\n\theight: 28px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-button,\n.editor-container.adg3-editor #toolbar #rte-toolbar a.aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar a.aui-button,\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-button:visited,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-button:visited {\n\tborder: none;\n\t/* table toolbar <buttons> */\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-contextual .aui-buttons button.aui-button {\n\tmargin-right: 1px;\n\tcolor: var(--ds-text, #405070);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button:hover:not(.disabled),\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button:hover:not(.disabled) {\n\tbackground-color: var(--ds-background-input, rgba(9, 30, 66, 0.08));\n\tborder-radius: 2px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-searchreplace.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button.disabled[aria-disabled='true']:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-searchreplace.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button.disabled[aria-disabled='true']:hover {\n\tcolor: var(--ds-text-subtle, #405070);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-searchreplace.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button[aria-disabled='true']:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-searchreplace.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button[aria-disabled='true']:hover {\n\tcolor: var(--ds-text-inverse, #ffffff);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\tbutton[aria-disabled='true'].aui-button,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\tbutton[aria-disabled='true'].aui-button {\n\tbackground-color: var(--ds-background-input, #ffffff);\n\tcolor: var(--ds-text-subtle, #405070);\n\tcursor: not-allowed;\n\topacity: 0.5;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button.disabled:hover\n\t.icon:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button.disabled:hover\n\t.icon:before {\n\tcolor: var(--ds-icon-disabled, #405070);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button#table-more-settings-trigger\n\t.aui-icon:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button#table-more-settings-trigger\n\t.aui-icon:before {\n\ttop: -4px;\n\tleft: -3px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar\n\t.aui-dropdown2-trigger.toolbar-trigger.active,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar\n\t.aui-dropdown2-trigger.toolbar-trigger.active,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar\n\t.toolbar-splitbutton:hover\n\t.toolbar-trigger,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar\n\t.toolbar-splitbutton:hover\n\t.toolbar-trigger,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar\n\t.toolbar-group\n\t.toolbar-trigger:focus,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar .toolbar-group .toolbar-trigger:focus,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar\n\t.toolbar-group\n\t.toolbar-trigger:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar .toolbar-group .toolbar-trigger:hover,\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar .toolbar-group button:focus,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar .toolbar-group button:focus,\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar .toolbar-group button:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar .toolbar-group button:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar\n\t.aui-dd-parent\n\t.aui-dd-trigger:focus,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar .aui-dd-parent .aui-dd-trigger:focus,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar\n\t.aui-dd-parent\n\t.aui-dd-trigger:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-toolbar .aui-dd-parent .aui-dd-trigger:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar\n\t.toolbar-group\n\t.active\n\t.toolbar-trigger:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar\n\t.toolbar-group\n\t.active\n\t.toolbar-trigger:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar2-primary\n\t.toolbar-splitbutton\n\t.toolbar-trigger:hover\n\t.aui-buttons\n\tli.toolbar-splitbutton:hover\n\ta:hover.toolbar-trigger#rte-button-color,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar2-primary\n\t.toolbar-splitbutton\n\t.toolbar-trigger:hover\n\t.aui-buttons\n\tli.toolbar-splitbutton:hover\n\ta:hover.toolbar-trigger#rte-button-color,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli.toolbar-splitbutton\n\ta:hover.toolbar-trigger#rte-button-color,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli.toolbar-splitbutton\n\ta:hover.toolbar-trigger#rte-button-color,\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-buttons li.toolbar-dropdown:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-buttons li.toolbar-dropdown:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli.toolbar-dropdown\n\ta:hover.toolbar-trigger,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli.toolbar-dropdown\n\ta:hover.toolbar-trigger {\n\tmargin-left: 0;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli#color-picker-control.toolbar-splitbutton.disabled:hover\n\t> .aui-dd-parent:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli#color-picker-control.toolbar-splitbutton.disabled:hover\n\t> .aui-dd-parent:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli#color-picker-control.toolbar-splitbutton.disabled:hover\n\t> .aui-dd-parent\n\t> a.toolbar-trigger:after,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli#color-picker-control.toolbar-splitbutton.disabled:hover\n\t> .aui-dd-parent\n\t> a.toolbar-trigger:after,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli#color-picker-control.toolbar-splitbutton.disabled:hover\n\t> a.toolbar-trigger\n\t.aui-icon:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli#color-picker-control.toolbar-splitbutton.disabled:hover\n\t> a.toolbar-trigger\n\t.aui-icon:before {\n\tcolor: var(--ds-icon-selected, #405070);\n\tbackground-color: var(--ds-background-input, #ffffff);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli#color-picker-control.toolbar-splitbutton:hover\n\t> .aui-dd-parent\n\t> a.toolbar-trigger:after,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli#color-picker-control.toolbar-splitbutton:hover\n\t> .aui-dd-parent\n\t> a.toolbar-trigger:after {\n\tcolor: var(--ds-text-inverse, #ffffff);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli#color-picker-control.toolbar-splitbutton:hover\n\t> .aui-dd-parent,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli#color-picker-control.toolbar-splitbutton:hover\n\t> .aui-dd-parent,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli#color-picker-control.toolbar-splitbutton:hover\n\t> .aui-dd-parent:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli#color-picker-control.toolbar-splitbutton:hover\n\t> .aui-dd-parent:hover {\n\tmargin-right: 1px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.toolbar-dropdown.disabled\n\t.dd-allocated:hover\n\t.toolbar-trigger\n\t.icon.aui-icon-small:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.toolbar-dropdown.disabled\n\t.dd-allocated:hover\n\t.toolbar-trigger\n\t.icon.aui-icon-small:before {\n\tcolor: var(--ds-icon-selected, #405070);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli#more-menu\n\t.active\n\ta#rte-button-more.toolbar-trigger.aui-dd-trigger.aui-button,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\tli#more-menu\n\t.active\n\ta#rte-button-more.toolbar-trigger.aui-dd-trigger.aui-button {\n\tmargin-left: 0;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons li.toolbar-item,\n#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons li.toolbar-item,\n.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons li.toolbar-item a.aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons li.toolbar-item a.aui-button {\n\theight: 24px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons.rte-toolbar-group-formatting,\n#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons.rte-toolbar-group-formatting,\n.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons.rte-toolbar-group-task-lists,\n#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons.rte-toolbar-group-task-lists {\n\tborder-left: none;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons.rte-toolbar-group-lists,\n#content.edit.adg3-editor #toolbar #rte-toolbar ul.aui-buttons.rte-toolbar-group-lists {\n\tmargin-right: 0;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.disabled\n\t.aui-button:hover\n\t.aui-icon-small:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.disabled\n\t.aui-button:hover\n\t.aui-icon-small:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.disabled\n\t.aui-button:hover\n\t.aui-icon-large:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.disabled\n\t.aui-button:hover\n\t.aui-icon-large:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.disabled\n\t.aui-button:hover\n\t.icon-close:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.disabled\n\t.aui-button:hover\n\t.icon-close:before {\n\tcolor: var(--ds-icon-selected, #405070);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.disabled\n\t.active.aui-button:hover\n\t.aui-icon-small:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.disabled\n\t.active.aui-button:hover\n\t.aui-icon-small:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.disabled\n\t.active.aui-button:hover\n\t.aui-icon-large:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.disabled\n\t.active.aui-button:hover\n\t.aui-icon-large:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.disabled\n\t.active.aui-button:hover\n\t.icon-close:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.disabled\n\t.active.aui-button:hover\n\t.icon-close:before {\n\tcolor: var(--ds-icon-inverse, #ffffff);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t> .aui-buttons\n\t> button.aui-button:not(.aui-dd-trigger),\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t> .aui-buttons\n\t> button.aui-button:not(.aui-dd-trigger) {\n\tbackground: none;\n\tborder: none;\n\tmargin-top: 0;\n\toutline: none;\n\tcolor: var(--ds-text-subtle, #405070);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t> .aui-buttons\n\t> button.aui-button:not(.aui-dd-trigger):active,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-contextual\n\t> .aui-buttons\n\t> button.aui-button:not(.aui-dd-trigger):active {\n\tbackground: var(--ds-background-neutral-pressed, rgba(179, 212, 255, 0.6));\n\tcolor: var(--ds-text-brand, #0052cc);\n\tbox-shadow: none;\n\t/*\n     Make toolbar buttons 'subtle' - we use an ID to be more specific than AUI's rules for 'normal' buttons.\n     */\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button,\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger,\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton > #rte-button-color,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton > #rte-button-color,\n.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-cancel.shared-drafts,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-cancel.shared-drafts,\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent {\n\tbackground: 0 0;\n\tborder-color: transparent;\n\tborder-radius: 2px;\n\tcolor: var(--ds-surface, #ffffff);\n\tmargin-right: 2px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button:hover,\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger:hover,\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton > #rte-button-color:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton > #rte-button-color:hover,\n.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-cancel.shared-drafts:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-cancel.shared-drafts:hover,\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent:hover {\n\t/*\n     AUI buttons in the same group have a left margin applied on hover so that the button doesn't\n     change its position when a border is rendered - now that we're faking 'subtle' button\n     styling we want to prevent this behaviour and override it with a margin of 0\n     */\n\t/* margin-left: 0; */\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button:hover:not(.disabled):not(.active),\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button:hover:not(.disabled):not(.active),\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-trigger.aui-button:hover:not(.disabled):not(.active),\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-trigger.aui-button:hover:not(.disabled):not(.active),\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger:hover:not(.disabled):not(.active),\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger:hover:not(.disabled):not(.active),\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color:hover:not(.disabled):not(.active),\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color:hover:not(.disabled):not(.active),\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts:hover:not(.disabled):not(.active),\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts:hover:not(.disabled):not(.active),\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.aui-dd-parent:hover:not(.disabled):not(.active),\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.aui-dd-parent:hover:not(.disabled):not(.active) {\n\tbackground-color: var(--ds-background-input, rgba(9, 30, 66, 0.08));\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button:active:not(.disabled):not(.active),\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button:active:not(.disabled):not(.active),\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-trigger.aui-button:active:not(.disabled):not(.active),\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-trigger.aui-button:active:not(.disabled):not(.active),\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger:active:not(.disabled):not(.active),\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger:active:not(.disabled):not(.active),\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color:active:not(.disabled):not(.active),\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color:active:not(.disabled):not(.active),\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts:active:not(.disabled):not(.active),\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts:active:not(.disabled):not(.active),\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.aui-dd-parent:active:not(.disabled):not(.active),\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.aui-dd-parent:active:not(.disabled):not(.active) {\n\tbackground: var(--ds-background-neutral-pressed, rgba(179, 212, 255, 0.6));\n\tcolor: var(--ds-text-brand, #0052cc);\n\tbox-shadow: none;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button:active:not(.disabled):not(.active)\n\t.aui-iconfont-dropdown,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button:active:not(.disabled):not(.active)\n\t.aui-iconfont-dropdown,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-trigger.aui-button:active:not(.disabled):not(.active)\n\t.aui-iconfont-dropdown,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-trigger.aui-button:active:not(.disabled):not(.active)\n\t.aui-iconfont-dropdown,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger:active:not(.disabled):not(.active)\n\t.aui-iconfont-dropdown,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger:active:not(.disabled):not(.active)\n\t.aui-iconfont-dropdown,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color:active:not(.disabled):not(.active)\n\t.aui-iconfont-dropdown,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color:active:not(.disabled):not(.active)\n\t.aui-iconfont-dropdown,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts:active:not(.disabled):not(.active)\n\t.aui-iconfont-dropdown,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts:active:not(.disabled):not(.active)\n\t.aui-iconfont-dropdown,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.aui-dd-parent:active:not(.disabled):not(.active)\n\t.aui-iconfont-dropdown,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.aui-dd-parent:active:not(.disabled):not(.active)\n\t.aui-iconfont-dropdown,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button:active:not(.disabled):not(.active)\n\ta.aui-dd-trigger:after,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button:active:not(.disabled):not(.active)\n\ta.aui-dd-trigger:after,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-trigger.aui-button:active:not(.disabled):not(.active)\n\ta.aui-dd-trigger:after,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-trigger.aui-button:active:not(.disabled):not(.active)\n\ta.aui-dd-trigger:after,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger:active:not(.disabled):not(.active)\n\ta.aui-dd-trigger:after,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger:active:not(.disabled):not(.active)\n\ta.aui-dd-trigger:after,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color:active:not(.disabled):not(.active)\n\ta.aui-dd-trigger:after,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color:active:not(.disabled):not(.active)\n\ta.aui-dd-trigger:after,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts:active:not(.disabled):not(.active)\n\ta.aui-dd-trigger:after,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts:active:not(.disabled):not(.active)\n\ta.aui-dd-trigger:after,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.aui-dd-parent:active:not(.disabled):not(.active)\n\ta.aui-dd-trigger:after,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.aui-dd-parent:active:not(.disabled):not(.active)\n\ta.aui-dd-trigger:after {\n\tcolor: var(--ds-text-brand, #0052cc);\n\tborder-top-color: var(--ds-border-brand, #0052cc);\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button.active,\n#content.edit.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button.active,\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button.active,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button.active,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger.active,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger.active,\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton > #rte-button-color.active,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-splitbutton > #rte-button-color.active,\n.editor-container.adg3-editor #toolbar #rte-toolbar #rte-button-cancel.shared-drafts.active,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-cancel.shared-drafts.active,\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent.active,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent.active,\n.editor-container.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button.active .aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button.active .aui-button,\n.editor-container.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button.active .aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar .toolbar-trigger.aui-button.active .aui-button,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger.active\n\t.aui-button,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger.active\n\t.aui-button,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color.active\n\t.aui-button,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color.active\n\t.aui-button,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts.active\n\t.aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar #rte-button-cancel.shared-drafts.active .aui-button,\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent.active .aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar .aui-buttons .aui-dd-parent.active .aui-button,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button.active\n\t.aui-button:hover,\n#content.edit.adg3-editor #toolbar #rte-toolbar li.toolbar-item.aui-button.active .aui-button:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-trigger.aui-button.active\n\t.aui-button:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-trigger.aui-button.active\n\t.aui-button:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger.active\n\t.aui-button:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger.active\n\t.aui-button:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color.active\n\t.aui-button:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color.active\n\t.aui-button:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts.active\n\t.aui-button:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts.active\n\t.aui-button:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.aui-dd-parent.active\n\t.aui-button:hover,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.aui-dd-parent.active\n\t.aui-button:hover {\n\tborder-color: var(--ds-border-focused, #42526e);\n\tbackground-color: var(--ds-background-brand-bold-hovered, #42526e);\n\tcolor: var(--ds-text-subtle, #405070);\n\tbox-shadow: none;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button.active\n\t.aui-icon-small:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button.active\n\t.aui-icon-small:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-trigger.aui-button.active\n\t.aui-icon-small:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-trigger.aui-button.active\n\t.aui-icon-small:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger.active\n\t.aui-icon-small:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger.active\n\t.aui-icon-small:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color.active\n\t.aui-icon-small:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color.active\n\t.aui-icon-small:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts.active\n\t.aui-icon-small:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts.active\n\t.aui-icon-small:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.aui-dd-parent.active\n\t.aui-icon-small:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.aui-dd-parent.active\n\t.aui-icon-small:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button.active\n\t.aui-icon-large:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button.active\n\t.aui-icon-large:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-trigger.aui-button.active\n\t.aui-icon-large:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-trigger.aui-button.active\n\t.aui-icon-large:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger.active\n\t.aui-icon-large:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> .aui-dd-parent\n\t> .toolbar-trigger.active\n\t.aui-icon-large:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color.active\n\t.aui-icon-large:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-splitbutton\n\t> #rte-button-color.active\n\t.aui-icon-large:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts.active\n\t.aui-icon-large:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-button-cancel.shared-drafts.active\n\t.aui-icon-large:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.aui-dd-parent.active\n\t.aui-icon-large:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-buttons\n\t.aui-dd-parent.active\n\t.aui-icon-large:before {\n\tcolor: var(--ds-icon-inverse, #ffffff);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button.disabled:hover\n\t.aui-icon-small:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button.disabled:hover\n\t.aui-icon-small:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button.disabled:hover\n\t.aui-icon-large:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button.disabled:hover\n\t.aui-icon-large:before {\n\tcolor: var(--ds-icon-selected, #405070);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button.disabled.active:hover\n\t.aui-icon-small:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button.disabled.active:hover\n\t.aui-icon-small:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button.disabled.active:hover\n\t.aui-icon-large:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tli.toolbar-item.aui-button.disabled.active:hover\n\t.aui-icon-large:before {\n\tcolor: var(--ds-icon-inverse, #ffffff);\n\t/* sections */\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-split.toolbar-contextual\n\t> .aui-buttons\n\t> button.aui-button\n\t> .trigger-text,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-split.toolbar-contextual\n\t> .aui-buttons\n\t> button.aui-button\n\t> .trigger-text {\n\tposition: relative;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-split.toolbar-contextual\n\t> .aui-buttons\n\t> button.aui-button.disabled:hover\n\t> .trigger-text,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-split.toolbar-contextual\n\t> .aui-buttons\n\t> button.aui-button.disabled:hover\n\t> .trigger-text {\n\tcolor: var(--ds-text-subtle, #405070);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-split.toolbar-contextual\n\t> .aui-buttons\n\t> button.aui-button.disabled,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-split.toolbar-contextual\n\t> .aui-buttons\n\t> button.aui-button.disabled {\n\topacity: 0.5;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tul.aui-buttons.rte-toolbar-group-table\n\t#table-picker-container,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tul.aui-buttons.rte-toolbar-group-table\n\t#table-picker-container,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tul.aui-buttons.rte-toolbar-group-table\n\t#table-picker-container\n\t.table-picker-box,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tul.aui-buttons.rte-toolbar-group-table\n\t#table-picker-container\n\t.table-picker-box {\n\tborder-radius: 5px;\n\tmargin: 6px 0 20px 0;\n\tborder: solid 1px var(--ds-border-inverse, #eff1ef);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tul.aui-buttons.rte-toolbar-group-table\n\t#table-picker-container\n\t.table-picker-box,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\tul.aui-buttons.rte-toolbar-group-table\n\t#table-picker-container\n\t.table-picker-box {\n\tborder: none;\n\tpadding: 1px 6px 1px 6px;\n\tmargin: 6px 0 13px 0;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar li.toolbar-item:active,\n#content.edit.adg3-editor #toolbar #rte-toolbar li.toolbar-item:active {\n\tbackground: var(--ds-background-neutral-pressed, rgba(179, 212, 255, 0.6));\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#format-dropdown.active\n\t#format-dropdown-display:after,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#format-dropdown.active\n\t#format-dropdown-display:after {\n\tborder-top-color: var(--ds-border-inverse, #ffffff);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#format-dropdown.active\n\t#format-dropdown-display\n\tspan.dropdown-text,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#format-dropdown.active\n\t#format-dropdown-display\n\tspan.dropdown-text {\n\tcolor: var(--ds-text-inverse, #ffffff);\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown #format-dropdown-display,\n#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown #format-dropdown-display {\n\tpadding: 0 10px 0 10px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#format-dropdown\n\t#format-dropdown-display\n\t.dropdown-text,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#format-dropdown\n\t#format-dropdown-display\n\t.dropdown-text {\n\tfont-size: 14px;\n\tmin-width: 70px;\n\t/* covers maximum expected i18n text width to avoid drop down flickering */\n\tcolor: var(--ds-text-subtle, #405070);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#format-dropdown\n\t#format-dropdown-display:active\n\t.dropdown-text,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#format-dropdown\n\t#format-dropdown-display:active\n\t.dropdown-text {\n\tcolor: var(--ds-text-brand, #0052cc);\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown li,\n#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown li {\n\theight: 32px;\n\tpadding: 0;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown a,\n#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown a {\n\tpadding: 6px 50px 6px 10px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h1 a,\n#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h1 a,\n.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h2 a,\n#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h2 a,\n.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h3 a,\n#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h3 a,\n.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h4 a,\n#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown .aui-dropdown .mce_h4 a {\n\tpadding: 0.4em 50px 0.5em 10px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar span.icon-close:before,\n#content.edit.adg3-editor #toolbar #rte-toolbar span.icon-close:before {\n\tcontent: '\\f11b';\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button {\n\theight: 24px;\n\tpadding: 4px 8px 4px 4px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button\n\tspan.aui-icon,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button\n\tspan.aui-icon {\n\tmargin-top: -4px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button\n\tspan.aui-icon:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button\n\tspan.aui-icon:before {\n\tmargin-left: -2px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button[data-tooltip='Close toolbar'],\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t.aui-buttons\n\tbutton.aui-button[data-tooltip='Close toolbar'] {\n\tpadding-right: 4px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t#pagelayout2-toolbar.aui-buttons\n\tbutton.aui-button,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t#pagelayout2-toolbar.aui-buttons\n\tbutton.aui-button {\n\theight: 24px;\n\tpadding: 4px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t#pagelayout2-toolbar.aui-buttons\n\tbutton.aui-button\n\tspan.aui-icon-small,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t#pagelayout2-toolbar.aui-buttons\n\tbutton.aui-button\n\tspan.aui-icon-small {\n\tmargin-top: -8px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t#pagelayout2-toolbar.aui-buttons\n\tbutton.aui-button\n\tspan.aui-icon-small:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-pl2-toolbar.toolbar-contextual\n\t#pagelayout2-toolbar.aui-buttons\n\tbutton.aui-button\n\tspan.aui-icon-small:before {\n\tmargin-left: -2px;\n\t/* icon-only buttons */\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .icon,\n#content.edit.adg3-editor #toolbar #rte-toolbar .icon {\n\ttext-indent: -9999em;\n\twidth: 16px;\n\tdisplay: inline-block;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #table-picker-container,\n#content.edit.adg3-editor #toolbar #rte-toolbar #table-picker-container {\n\tposition: absolute;\n\tz-index: 10001;\n\tbackground: var(--ds-background-input, #ffffff);\n\t/* Styles for colour selection in the dropdown */\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar div.color-picker,\n#content.edit.adg3-editor #toolbar #rte-toolbar div.color-picker {\n\tleft: -11px;\n\t/* align with the colour button, and not the drop-down trigger */\n\tposition: absolute;\n\toverflow: auto;\n\tpadding: 6px;\n\twidth: 160px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar div.color-picker ul,\n#content.edit.adg3-editor #toolbar #rte-toolbar div.color-picker ul {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar div.color-picker ul li,\n#content.edit.adg3-editor #toolbar #rte-toolbar div.color-picker ul li {\n\tdisplay: inline;\n\tfloat: left;\n\theight: 16px;\n\tline-height: 16px;\n\tpadding: 2px;\n\twidth: 16px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar div.color-picker ul li a,\n#content.edit.adg3-editor #toolbar #rte-toolbar div.color-picker ul li a {\n\tborder: 1px solid var(--ds-border-bold, #ddd);\n\tborder-radius: 2px;\n\tdisplay: block;\n\theight: 14px;\n\tline-height: 14px;\n\tpadding: 0px;\n\ttext-align: justify;\n\twidth: 14px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #page-layout-2-group,\n#content.edit.adg3-editor #toolbar #rte-toolbar #page-layout-2-group {\n\tmargin-right: 0px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar ul.rte-toolbar-group-insert,\n#content.edit.adg3-editor #toolbar #rte-toolbar ul.rte-toolbar-group-insert {\n\tmargin-left: -1px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar ul.rte-toolbar-group-task-lists,\n#content.edit.adg3-editor #toolbar #rte-toolbar ul.rte-toolbar-group-task-lists {\n\tpadding-left: 0;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-table-merge:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-table-merge:before {\n\tcontent: '\\f19d';\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-table-split:before,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-table-split:before {\n\tcontent: '\\f1a4';\n\t/*\n     The formatting toolbar needs special overrides because its markup differs from the other dropdowns\n     in the toolbar, and its appearance should match the ADG guidelines for texts (rather than icons).\n     */\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown #format-dropdown-display,\n#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown #format-dropdown-display {\n\tcolor: var(--ds-text, #333);\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #format-dropdown.active .aui-button,\n#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown.active .aui-button {\n\tborder-color: var(--ds-border-focused, #405070);\n\tcolor: var(--ds-text-inverse, #ffffff);\n\tbackground-color: var(--ds-background-brand-bold-hovered, #405070);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#format-dropdown.disabled\n\t#format-dropdown-display:hover\n\t.dropdown-text,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#format-dropdown.disabled\n\t#format-dropdown-display:hover\n\t.dropdown-text {\n\tcolor: var(--ds-text-subtle, #405070);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#format-dropdown.active\n\t#format-dropdown-display,\n#content.edit.adg3-editor #toolbar #rte-toolbar #format-dropdown.active #format-dropdown-display {\n\tcolor: var(--ds-text-inverse, #fff);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-dropdown\n\t.aui-dropdown\n\tli.dropdown-item.active,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-dropdown\n\t.aui-dropdown\n\tli.dropdown-item.active {\n\tbackground: none;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-dropdown\n\t.aui-dropdown\n\tli.dropdown-item.active\n\ta,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-dropdown\n\t.aui-dropdown\n\tli.dropdown-item.active\n\ta {\n\tbackground-color: var(--ds-background-input, rgba(9, 30, 66, 0.08));\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-dropdown\n\t.aui-dropdown\n\tli.dropdown-item.active:active\n\ta,\n#content.edit.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.toolbar-dropdown\n\t.aui-dropdown\n\tli.dropdown-item.active:active\n\ta {\n\tbackground: var(--ds-background-neutral-pressed, rgba(179, 212, 255, 0.6));\n\tcolor: var(--ds-text-brand, #0052cc);\n}\n\n@media only screen and (max-width: 1024px) {\n\t/* AUI 6.1.4 specific CSS */\n\t.editor-container.adg3-editor .contenteditor #draft-status,\n\t#content.edit.adg3-editor .contenteditor #draft-status {\n\t\tdisplay: none !important;\n\t}\n}\n\nbody[data-aui-version='6.1.4-SNAPSHOT'] .aui-buttons .aui-button ~ .aui-button:hover,\nbody[data-aui-version='6.1.4-SNAPSHOT'] .aui-buttons .aui-button ~ .aui-button:focus,\nbody[data-aui-version='6.1.4-SNAPSHOT'] .aui-buttons .aui-button ~ .aui-button:active {\n\tmargin-left: 0;\n\t/* AUI 7 & 8 specific CSS */\n}\n\nbody[data-aui-version^='7'] #rte-toolbar .toolbar-dropdown .aui-dropdown li.dropdown-item.active a,\nbody[data-aui-version^='8'] #rte-toolbar .toolbar-dropdown .aui-dropdown li.dropdown-item.active a {\n\tcolor: var(--ds-text, #333);\n}\n\nbody[data-aui-version^='7'] #rte-toolbar div.color-picker ul li,\nbody[data-aui-version^='8'] #rte-toolbar div.color-picker ul li {\n\tmargin-top: 4px;\n}\n\n.panel_wrapper div.current {\n\theight: 245px;\n}\n\n.advfield {\n\twidth: 200px;\n}\n\n#class {\n\twidth: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
